/* 三國逗陣打 · 遊戲頁：選將、主迴圈、輸入、HUD、商店、戰況、結算 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from '../core/sg.ts';
import { loadFilter, applyFilter, filterBar, bindFilter, setCount } from './herofilter.ts';
import { VERSION } from '../version.ts';
import { chapterOpen } from '../campaign/open.ts';

const $ = (id) => document.getElementById(id);
const FACTION = { shu: '蜀', wu: '吳', wei: '魏' };
const FBG = { shu: '#1f3326', wu: '#3a1d1b', wei: '#1b2440' };
const CAT_COL = { 兵器: '#e27a5a', 甲冑: '#7fb6ff', 典籍: '#c9a2ff', 坐騎: '#8fd19e', 配件: '#e9c46a', 軍需: '#d8cdb5', 神器: '#ffcf6a' };
const DT = 1 / 30;
const fmt = (t) => String(Math.floor(t / 60)).padStart(2, '0') + ':' + String(Math.floor(t % 60)).padStart(2, '0');

// 頭像快取：畫一次骨架很貴（選將畫面一次要幾十張），同一個武將物件＋尺寸畫好就留著，之後只貼圖
const portraitCache = new WeakMap();
function portrait(cv, h, size) {
  const dpr = Math.min(2, window.devicePixelRatio || 1), S = size || 60, px = Math.round(S * dpr);
  cv.width = px; cv.height = px;
  let bySize = portraitCache.get(h);
  if (!bySize) portraitCache.set(h, (bySize = new Map()));
  let img = bySize.get(px);
  if (!img) {
    img = document.createElement('canvas'); img.width = img.height = px;
    const ctx = img.getContext('2d'); ctx.setTransform(px / 64, 0, 0, px / 64, 0, 0);
    const g = ctx.createLinearGradient(0, 0, 0, 64); g.addColorStop(0, FBG[h.faction] || '#222'); g.addColorStop(1, '#12161f');
    ctx.fillStyle = g; ctx.fillRect(0, 0, 64, 64);
    ctx.save(); ctx.translate(29, 98); SG.drawHero(ctx, h, SG.poseOf(h, 'idle', 0.25), 0); ctx.restore();
    bySize.set(px, img);
  }
  cv.getContext('2d').drawImage(img, 0, 0);
}

// ================= 選將 =================
let chosen = SG.HEROES.find((h) => h.id === 'guanyu');
const tiles = new Map();
// 篩選、排序、搜尋（v0.3.0，herofilter.ts）
const pickFilter = loadFilter('practice');
$('fac').className = ''; $('fac').innerHTML = filterBar('pfbar', pickFilter);
bindFilter($('fac'), 'practice', pickFilter, () => renderGrid());
SG.HEROES.forEach((h) => {
  const b = document.createElement('button');
  b.type = 'button'; b.className = 'tile'; b.dataset.f = h.faction;
  b.innerHTML = `<canvas aria-hidden="true"></canvas><b>${h.name}</b><small>${h.roleText}</small><i class="mb" hidden></i><i class="dbl" hidden>今日</i>`;
  b.addEventListener('click', () => { chosen = h; renderChosen(); tiles.forEach((t, id) => t.setAttribute('aria-pressed', String(id === h.id))); });
  b.addEventListener('dblclick', () => start(h));
  portrait(b.querySelector('canvas'), h, 60);
  tiles.set(h.id, b);
});
function renderGrid() {
  const g = $('grid'); g.innerHTML = '';
  const dh = Meta.dailyHero();
  const list = applyFilter(pickFilter); setCount($('fac'), list.length);
  if (!list.length) g.innerHTML = '<p class="on-note">沒有符合的武將</p>';
  list.forEach((h) => {
    const t = tiles.get(h.id), rec = Meta.profile.heroes[h.id], lv = rec ? Meta.masteryOf(rec.xp).lv : 0, mb = t.querySelector('.mb');
    t.setAttribute('aria-pressed', String(h === chosen));
    mb.hidden = !lv; mb.textContent = '熟' + lv; mb.title = rec ? Meta.masteryOf(rec.xp).name : '';
    t.querySelector('.dbl').hidden = h !== dh;
    g.appendChild(t);
  });
}

// ================= 局外成長：軍階、每日軍令、今日武將、挑戰 =================
const Meta = SG.Meta;
let challenge = null;
try { const c = new URLSearchParams(location.search).get('c'); if (c) challenge = Meta.decodeChallenge(c); } catch (e) { /* 網址壞了就當沒有 */ }
if (challenge) { chosen = challenge.hero; }
const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
// ---------- 操作設定 ----------
const SCHEMES = {
  moba: { name: '滑鼠 MOBA', skillKeys: ['KeyQ', 'KeyW', 'KeyE', 'KeyR'], labels: ['Q', 'W', 'E', 'R'],
    rows: [['右鍵', '移動；點敵人＝攻擊它並進入攻擊狀態；點自己殘血小兵反補（出手後移動可取消收招）'], ['Shift＋右鍵', '排路徑：依序走過每個點（小地圖上也可以）；一般右鍵、A、S 會清掉'], ['左鍵', '點單位：查看它的狀態、技能、裝備（離開視野自動收起）；按住空地拖曳畫面'], ['A＋左鍵', '攻擊：點敵人就打它；點地面就走過去，途中照順序打。進入攻擊狀態後，目標倒下會自動找下一個：射程內武將 → 射程內小兵／塔 → 射程外武將 → 射程外小兵（近的優先；呂布、玉璽不會自動打）'], ['（攻擊狀態）', 'S 或右鍵移動會結束（曹彰上馬騎射時移動不會結束）；施法、防禦結束後回到攻擊狀態'], ['Q W E R', '技能，朝游標施放；技能收招可接下一招（連段）'], ['S', '停止：中止攻擊狀態'], ['D', '防禦（按住）：物防 ×1.2 再 +8，只擋物理，控制照吃；放開回到防禦前的狀態'], ['Alt＋左鍵', '隊伍訊號「注意這裡」（點在敵人身上是「攻擊目標」）；Ctrl＋左鍵是「危險，撤退」；在小地圖上也可以'], ['G（按住）', '訊號輪盤：往上集合、往右正在前往、往下危險、往左敵人消失，放開送出'], ['空白（按住）', '鏡頭對準武將；放開回到原本的鏡頭（自由鏡頭時游標靠邊捲動、點小地圖移鏡頭）'], ['Y', '鏡頭一直跟隨／自由']] },
  wasd: { name: 'WASD 動作', skillKeys: ['KeyQ', 'KeyE', 'KeyR', 'KeyF'], labels: ['Q', 'E', 'R', 'F'],
    rows: [['W A S D', '移動'], ['左鍵', '朝游標攻擊（按住連打，出手後移動可取消收招）'], ['Q E R F', '技能，朝游標施放；收招可接下一招'], ['右鍵／Shift', '防禦（按住），面向游標'], ['空白（按住）', '鏡頭對準武將']] },
  classic: { name: '鍵盤經典', skillKeys: ['KeyQ', 'KeyW', 'KeyE', 'KeyR'], labels: ['Q', 'W', 'E', 'R'],
    rows: [['方向鍵', '移動'], ['Z', '攻擊（按住連打）'], ['C', '防禦（按住）'], ['Q W E R', '技能，朝面向的最近敵人施放']] },
};
const settings = { scheme: 'moba', cast: 'hold', mode: 'std', battle: 'chibi', cam: 'free', gfx: 'auto', haptics: true, camDist: 'near' };
try { Object.assign(settings, JSON.parse(localStorage.getItem('sankuo-controls') || '{}')); } catch (e) { /* 無法讀取就用預設 */ }
if (settings.cast !== 'hold' && settings.cast !== 'click') settings.cast = 'hold'; // 舊設定「按下立即施放」已移除
settings.scheme = 'moba'; // 只提供滑鼠 MOBA 操作；WASD／鍵盤經典保留在程式裡，設定頁不再提供
if (settings.cam !== 'free' && settings.cam !== 'lock') settings.cam = 'free';
if (!['auto', 'high', 'low'].includes(settings.gfx)) settings.gfx = 'auto';
// 畫質：高＝2 倍解析度、不限幀數；省電＝1 倍、30 FPS；自動＝桌機 2 倍、手機 1.5 倍，太卡就分兩步降（先 1 倍，再 30 FPS）
// v0.5.4.1：桌機自動也會降（以前桌機的自動不量幀數，Retina 螢幕畫不動時一直卡）
// 光影層（SG.SHADE）是畫風的核心，任何畫質都不關：關掉畫面會變回扁平的純平塗
const GFX = { high: { dpr: 2, fps: 0, shade: true }, low: { dpr: 1, fps: 30, shade: true } };
function gfxProfile(touch) {
  if (settings.gfx === 'high' || settings.gfx === 'low') return Object.assign({ name: settings.gfx }, GFX[settings.gfx]);
  // 手機自動：上限每秒 60 幀（v0.3.4：120Hz 螢幕會畫到 120 幀，模擬只有 30 Hz，多畫的都是發熱）
  return touch ? { name: 'auto', dpr: 1.5, fps: 60, shade: true, auto: true } : { name: 'auto', dpr: 2, fps: 0, shade: true, auto: true };
}
function applyGfx(g) { SG.GFX = g; SG.SHADE = g.shade; if (view) view.resize(); fpsMon.t = -3; fpsMon.n = 0; } // 換畫質後 3 秒不量（重建畫面會卡一下）
const fpsMon = { t: 0, n: 0, slow: 0 }; // 自動畫質：每 3 秒量一次平均幀數（t 是負的表示暫停量測）
document.addEventListener('fullscreenchange', () => { fpsMon.t = -3; fpsMon.n = 0; fpsMon.slow = 0; }); // 進出全螢幕會卡一下，不算
// 戰役：單機也能打 5v5／3v3／1v1，規則與連線模式相同（server/lobby.ts）
const BATTLES = {
  chibi: { name: '赤壁之戰', size: 5, note: '三路全開，拆掉對方本營獲勝', sim: {} },
  guandu: { name: '官渡之戰', size: 3, note: '只開上、下兩路的小規模會戰', sim: { lanes: ['top', 'bot'], size: 3 } },
  changban: { name: '長坂坡之戰', size: 1, note: '只開中路，先兩殺或先拆一座城寨者勝', sim: { lanes: ['mid'], size: 1, solo: true } },
};
if (!BATTLES[settings.battle]) settings.battle = 'chibi';
const saveSettings = () => { try { localStorage.setItem('sankuo-controls', JSON.stringify(settings)); } catch (e) { /* 忽略 */ } };
// ---------- 操作指南（按 H）：分組卡片，每行「按鍵圖示＋短動作」，一眼看懂 ----------
// keys：鍵帽字；'ML'／'MR' 是滑鼠左右鍵（分隔符見 keysHTML）
const GUIDE = () => {
  const hold = settings.cast === 'hold';
  return [
    { t: '移動與戰鬥', c: '#f0b43c', rows: [['MR', '移動', '點敵人＝攻擊'], ['A+ML', '攻擊', '打完自動找下一個；S 或移動才停'], ['S', '停止', '中止攻擊狀態'], ['D', '防禦', '按住，物防 ×1.2＋8（只擋物理）；放開回到原本狀態'], ['ML', '查看', '點單位看狀態、技能；拖曳移動畫面']] },
    { t: '技能', c: '#c9a2ff', rows: [['Q W E R', '施放技能', hold ? '按住看範圍，放開施放' : '按一下看範圍，左鍵施放'], ['Alt+Q', '升級技能', '或點技能上的＋'], ['O', '屬性加強', '全屬性 +2'], ['F', '謀略', '開戰前在選將畫面挑一個']] },
    { t: '道具與據點', c: '#8fe08a', rows: [['1~6', '使用道具', '六格道具欄'], ['B', '回城', '原地 3 秒'], ['P', '商店', '本營、神秘商店、長江商船']] },
    { t: '鏡頭', c: '#6fb3ff', rows: [['Space', '對準武將', '按住'], ['Y', '跟隨／自由'], ['ML', '點小地圖', '鏡頭跳過去']] },
    { t: '隊伍訊號', c: '#ffd46b', rows: [['Alt+ML', '注意這裡', '點敵人是「攻擊目標」'], ['Ctrl+ML', '危險，撤退'], ['G', '訊號輪盤', '按住，往方向選，放開送出']] },
    { t: '介面', c: '#a39e93', rows: [['Tab', '戰況'], ['Enter', '聊天', '連線對戰時'], ['M', '音樂'], ['Esc', '暫停／取消'], ['H', '這份指南']] },
  ];
};
const keyCap = (k) => (k === 'ML' || k === 'MR' ? `<i class="ms ${k === 'ML' ? 'ml' : 'mr'}" title="滑鼠${k === 'ML' ? '左' : '右'}鍵"></i>` : `<kbd class="kc${k.length > 2 ? ' wide' : ''}">${k === 'Space' ? '空白' : k}</kbd>`);
// '/' 擇一、'~' 範圍、空白是並排的一組鍵、'+' 組合鍵
const keysHTML = (spec) => spec.split('/').map((alt) => alt.split('~').map((rg) => rg.split(' ').map((one) => one.split('+').map(keyCap).join('<span class="kp">+</span>')).join('')).join('<span class="ko">～</span>')).join('<span class="ko">／</span>');
function guideHTML(compact) {
  return `<div class="gd-grid${compact ? ' compact' : ''}">${GUIDE().map((g) => `<section class="gd-card" style="--gc:${g.c}"><h4>${g.t}</h4>${g.rows.map(([k, a, n]) => `<div class="gd-row"><span class="gd-keys">${keysHTML(k)}</span><span class="gd-act"><b>${a}</b>${n ? `<small>${n}</small>` : ''}</span></div>`).join('')}</section>`).join('')}</div>`;
}
const keyRows = () => SCHEMES[settings.scheme].rows.concat([['Alt＋技能鍵', '學技能（或點技能上的 ＋）'], ['O', '屬性加強：全屬性 +2'], ['1–6', '使用道具'], ['B', '回城：原地 3 秒後傳回本營溫泉（移動、出手或被打會中斷）'], ['P', '商店（本營內買賣）'], ['Tab', '戰況'], ['M', '背景音樂開／關'], ['Esc', '暫停']]);

// 元素標籤與反應說明（elements.js）
const elTag = (s) => { const e = SG.EL && s._el && SG.EL[s._el]; return e ? `<span class="el" style="--ec:${e.col}" title="${e.name}屬性">${e.name}</span>` : ''; };
const EL_REACT = { fire: ['melt', 'firestorm', 'burst', 'steam', 'wildfire'], ice: ['melt', 'freeze', 'spread'], thunder: ['shatter', 'conduct', 'burst'], wind: ['firestorm', 'spread'], poison: ['burst', 'spread'], shadow: ['purge', 'drain'], holy: ['purge'], earth: ['shatter', 'crystal'] };
// ---------- 技能預覽：選將面板最上方的小畫面，跑一場真的模擬、用遊戲本身的畫面畫出來，跟實戰一模一樣 ----------
// 練功場在中路四成處（魏軍取鏡像），城寨、小兵、野怪都不出。對面兩名敵將來回走動（控制技才看得出效果），血不會掉到底。
// 每一招照「腳本」演：武將站在這招的射程裡、時間到放招、兩段式再按一次；有些招另外寫專屬腳本（PV_SCRIPTS）
const pvCanvas = document.createElement('canvas'); pvCanvas.id = 'pv'; pvCanvas.className = 'pv'; pvCanvas.style.aspectRatio = '2 / 1';
let pvWorld = null, pvView = null, pvHero = null, pvRows = [], pvCur = -1, pvT = 0, pvNext = 0, pvRun = null, pvRaf = 0, pvLast = 0, pvAcc = 0;
// 整名武將共用的設定：甘寧的招都跟水有關，全部在江面上演
const PV_HEROES = { ganning: { water: true } };
// 專屬腳本：key 是「武將 id:技能格」。dur 演多久；flee 敵將一路往後跑（數字：跑多遠）；chase 放完追著敵將走；water 在江面上演；run 每一步自己下指令（回傳 true 代表這一步處理完了）
const YX_CARDS = ['blue', 'red', 'gold'];
const PV_SCRIPTS = {
  // 楊修「解謎」：三張牌效果都不同，一張一張演（一合酥、闊門、雞肋）：抽牌 → 等到那張亮起再按一次鎖定 → 普攻打出去
  'yangxiu:1': { dur: 10.6, run({ w, me, foe, t, c }) {
    const k = Math.floor((t - 0.4) / 3.3), t0 = 0.4 + k * 3.3;
    if (k < 0 || k > 2) return true;
    if (c.k !== k) { c.k = k; c.locked = false; me.cd[1] = 0; me.input.skill = { i: 1, x: foe.x, y: foe.y }; me.input.target = null; return true; }
    if (!c.locked && me.cardSel && t > t0 + 0.3 && SG.cardShown(w, me) === YX_CARDS[k]) { me.cd[1] = 0; me.input.skill = { i: 1, x: foe.x, y: foe.y }; c.locked = true; return true; }
    if (c.locked && me.card) me.input.target = foe;
    return true;
  } },
  // 曹丕「煮豆燃萁」：點火之後敵將要一直走，累計 700 才會再爆；曹丕跟在後面，鏡頭才拍得到兩人
  'caopi:0': { dur: 5.6, flee: true, chase: true },
  // 曹純「長坂追擊」：敵將背對他逃跑，他追上去打
  'caochun:2': { dur: 5, flee: 600 },
  // 典韋「妖火」：標記之後要走到身邊打幾下，才看得到破甲
  'dianwei:3': { dur: 5.4 },
  // 鄧艾「裹氈滾下」：放完朝敵將滾過去
  'dengai:0': { chase: true },
  // 孟獲「吞食」：只能吞小兵，放一隻敵方小兵在他面前
  'menghuo:0': { run({ w, me, foe, t, c }) {
    if (!c.m) c.m = w.spawnMinion(1 - me.team, 'mid', ...SG.along(me.x, me.y, SG.dirTo(me, foe.x, foe.y), 90), false);
    if (c.castT < 0 && t > 0.5 && c.m.alive) { me.input.skill = { i: 0, x: c.m.x, y: c.m.y }; c.castT = t; }
    return true;
  } },
};
const pvRange = (me, row) => {
  const sk = row.s;
  if (!sk || sk.passive || sk.tg || sk.arch === 'buff') return (me.range || 150) * 0.8;
  const a = SG.aimOf(sk, Math.max(1, me.skillLv[row.i] || 1));
  return a.kind === 'self' || a.kind === 'cone' ? (a.area || a.range || 200) * 0.7 : (a.range || 300) * 0.65;
};
const pvScript = (h, row) => {
  const sc = PV_SCRIPTS[h.id + ':' + row.i] || {}, sk = row.s || {};
  const two = !!(sk.then || (sk.recast && sk.recast < 60));
  return { dur: two ? 5 : 4.2, water: /水裡/.test(sk.desc || ''), ...PV_HEROES[h.id], ...sc };
};
// 瀏覽器測試用：看預覽演到哪；pvSim 不畫畫面、把一招的腳本快轉演完，回傳敵將受到的傷害與控制
SG.pvDebug = () => ({ w: pvWorld, run: pvRun });
SG.pvSim = (h, r, trace) => {
  setPreviewHero(h); playPreview(r, true);
  const w = pvWorld, foes = w.pvFoes, hp0 = foes.map((u) => u.hp), cc = new Set();
  let dmg = 0;
  for (let k = 0; k < pvNext / DT; k++) {
    pvInput(); w.step(DT);
    if (trace && k % 3 === 0) trace.push([pvRun.t.toFixed(1), w.player.x | 0, w.player.y | 0, w.player.act && w.player.act.kind, foes.map((u) => (u.x | 0) + ',' + (u.y | 0) + ',' + u.pv.wait.toFixed(1)).join(' '), w.projs.map((q) => (q.x | 0) + ',' + (q.y | 0)).join(' ')].join(' '));
    foes.forEach((u, j) => { dmg += Math.max(0, hp0[j] - u.hp); hp0[j] = u.hp; for (const c of ['stun', 'knockup', 'root', 'slow', 'freeze', 'silence', 'fear', 'taunt']) if (u.st[c] > 0) cc.add(c); });
  }
  return { dmg: Math.round(dmg), cc: [...cc], dur: pvNext };
};
const pvSkin = {}; // 同一名武將同一款造型共用一份（換造型才重開預覽）
let pvTry = null; // 試看還沒買的傳說級造型：{ h 武將, sk 造型 }，只換預覽，不換出戰造型
const pvSkinned = (h) => { const sk = pvTry && pvTry.h === h.id ? pvTry.sk : Meta.skinUnlocked(h.id, Meta.skinFor(h.id)) ? Meta.skinFor(h.id) : 'base', key = h.id + ':' + sk; return pvSkin[key] || (pvSkin[key] = Meta.skinned(h, sk)); };
function setPreviewHero(h) {
  if (pvHero !== h || !pvWorld) {
    pvHero = h; pvCur = -1; pvT = 0; pvNext = 0.6; pvRun = null; pvAcc = 0;
    pvRows = SG.skillRows(h).map((r, k, all) => ({ ...r, f: h.forms && k < all.length - 1 ? Math.floor(k / 3) : null }));
    if (SG.CAMPAIGN) SG.CAMPAIGN.leave(); // 列傳地圖還在就先換回赤壁
    const w = new SG.World({ hero: h });
    w.waveT = w.bossT = w.cartT = w.wind.next = w.seal.t = 1e9; w.camps.forEach((c) => (c.t = 1e9));
    w.units = w.units.filter((u) => u.kind !== 'tower');
    w.heroes().forEach((u) => { u.ai = null; u.human = true; u.input = {}; u.lv = 25; u.skillLv = [4, 4, 4, 3]; w.recalc(u, true); });
    w.pvFoes = w.heroes(1 - w.player.team).slice(0, 2); w.pvAlly = w.heroes(w.player.team).find((u) => u !== w.player);
    pvWorld = w;
    if (pvView) pvView.rebind(w); else pvView = new SG.View(pvCanvas, w, document.createElement('canvas'), { camH: 520, noCutin: true });
    pvView.camLock = false; // 鏡頭自己擺：對準武將與木樁的中間（pvLoop）
    pvPlace(pvRows[0] || null, {});
  }
  if (!pvRaf) { pvLast = performance.now(); pvRaf = requestAnimationFrame(pvLoop); }
}
// 每一招開始前把場面擺好：上一招留下的投射物、場地、召喚物清掉，全員回血歸位。
// 武將站在這招射程的六、七成處，身後站一名友將（治療、護盾這類招的對象）。
// 敵將在武將對面橫向來回走，走到一端停 1.6 秒（武將趁這時放招，飛得慢的招也打得中；被控住的接著就走不動）。flee：一路往後跑
function pvPlace(row, sc) {
  const w = pvWorld, me = w.player, M = SG.MAP, sg = me.team ? -1 : 1;
  w.projs = []; w.zones = [];
  w.units = w.units.filter((u) => u.kind === 'hero' || u.structure);
  for (const u of w.heroes()) { if (!u.alive) w.revive(u); u.input = {}; u.act = null; u.rc = null; u.tgOn = null; u.bean = null; u.cardSel = null; u.card = null; u.hp = u.maxHp; u.mp = u.maxMp; u.cd = [0, 0, 0, 0]; }
  // 場地：平常在中路的路面上；說明提到「水裡」的招移到江面（浮橋旁），沿著江演
  let A, dir;
  if (sc.water) {
    const [cx, cy] = M.center, t = -440 * sg;
    A = [cx + t, cy + 0.779 * t]; dir = SG.dirTo({ x: A[0], y: A[1], f: 1 }, cx - t, cy - 0.779 * t);
  } else {
    const L = M.laneLen.mid, s0 = L * (me.team ? 0.6 : 0.4);
    A = M.laneAt('mid', s0); const B = M.laneAt('mid', s0 + sg * 100); dir = SG.dirTo({ x: A[0], y: A[1], f: 1 }, B[0], B[1]);
  }
  const d = Math.max(60, Math.min(480, row ? pvRange(me, row) : 300)), perp = [-dir[1], dir[0]];
  [me.x, me.y] = SG.along(A[0], A[1], dir, -d / 2); me.f = dir[0] >= 0 ? 1 : -1;
  const amp = Math.max(30, Math.min(140, d * 0.4));
  w.pvFoes.forEach((u, k) => {
    const home = SG.along(...SG.along(A[0], A[1], dir, d / 2 + k * 60), perp, k ? 60 : -30);
    u.f = -me.f;
    if (sc.flee) { [u.x, u.y] = home; u.pv = { pts: [SG.along(home[0], home[1], dir, sc.flee === true ? 1200 : sc.flee)], k: 0, wait: 0 }; } // flee 是數字：跑這麼遠就停下
    else { const pts = [SG.along(home[0], home[1], perp, amp), SG.along(home[0], home[1], perp, -amp)]; [u.x, u.y] = pts[1 - k]; u.pv = { pts, k, wait: 0 }; }
    u.pvPrev = [u.x, u.y];
  });
  w.heroes().filter((u) => u !== me && u !== w.pvAlly && !w.pvFoes.includes(u)).forEach((u) => { u.x = M.bases[u.team].x; u.y = M.bases[u.team].y; });
  if (w.pvAlly) { [w.pvAlly.x, w.pvAlly.y] = SG.along(...SG.along(me.x, me.y, dir, -70), perp, 70); w.pvAlly.f = me.f; w.pvAlly.hp = w.pvAlly.maxHp * 0.6; }
}
function playPreview(r, auto) {
  if (!pvWorld) return;
  const w = pvWorld, me = w.player, row = pvRows[r];
  if (!row) return;
  const sc = pvScript(pvHero, row);
  pvCur = r; pvT = 0; pvNext = auto ? sc.dur : sc.dur + 1.5;
  document.querySelectorAll('[data-pv] li[data-r]').forEach((li) => li.classList.toggle('on', +li.dataset.r === r));
  if (row.f != null) w.setForm(me, row.f);
  pvPlace(row, sc);
  pvRun = { row, sc, t: 0, castT: -1, again: false };
}
// 每一步的操作：敵將照路線走；時間到就放招（瞄準敵將走過去的位置），兩段式再按一次；被動、開關技、自身強化就普攻
function pvInput() {
  const w = pvWorld, me = w.player, c = pvRun;
  me.mp = me.maxMp;
  for (const u of w.pvFoes) {
    if (u.alive) u.hp = Math.max(u.hp, u.maxHp * 0.3);
    u.vel = [(u.x - u.pvPrev[0]) / DT, (u.y - u.pvPrev[1]) / DT]; u.pvPrev = [u.x, u.y];
    const pv = u.pv, p = pv && pv.pts[pv.k];
    if (!p) continue;
    if (pv.wait > 0) { pv.wait -= DT; u.input = {}; continue; }
    if (Math.hypot(u.x - p[0], u.y - p[1]) < 20 && pv.pts.length > 1) { pv.k = (pv.k + 1) % pv.pts.length; pv.wait = 1.6; u.input = {}; continue; }
    u.input = { moveTo: p.slice() };
  }
  const foe = w.pvFoes.find((u) => u.alive) || w.pvFoes[0];
  if (!c || !foe) return;
  c.t += DT;
  const { row, sc } = c, sk = row.s, i = row.i;
  if (sc.run && sc.run({ w, me, foe, t: c.t, c, row })) return; // c：這一次演出的狀態，腳本自己的記號也放這裡
  if (sk.passive) { if (c.t > 0.3) me.input.target = foe; return; }
  const a = SG.aimOf(sk, Math.max(1, me.skillLv[i] || 1)), lead = (a.kind === 'dir' || a.kind === 'point') && !(foe.pv.wait > 0) ? 0.35 : 0; // 停著就不預判
  // 對友方放的單體招（說明寫「友」）瞄身後的友將，其他瞄敵將（走動中就往前多瞄一點）
  const ally = a.kind === 'unit' && /友/.test(sk.desc) && w.pvAlly;
  const at = () => (ally ? { i, x: ally.x, y: ally.y } : { i, x: foe.x + foe.vel[0] * lead, y: foe.y + foe.vel[1] * lead });
  // 放招：敵將剛停下來的時候（逃跑的腳本不等，晚了也照放）
  if (c.castT < 0 && c.t > 0.3 && (foe.pv.wait > 1.4 || sc.flee || c.t > 2)) { me.cd[i] = 0; me.input.skill = at(); c.castT = c.t; c.hp = w.pvFoes.reduce((n, u) => n + u.hp, 0); return; }
  if (c.castT < 0) return;
  me.input.aim = [foe.x, foe.y]; // 引導、連射這類招：方向一直對著敵將
  if (sc.chase) me.input.moveTo = [foe.x, foe.y];
  if (!c.again && c.t > c.castT + 1 && me.rc && me.rc[i]) { me.input.skill = at(); c.again = true; return; }
  // 接著普攻：開關技、自身強化；或是放完 1.2 秒都沒打到人的招（標記、減益、增益），打幾下才看得出效果
  if (!c.follow && ((c.t > c.castT + 0.6 && (sk.tg || sk.arch === 'buff')) || (c.t > c.castT + 1.2 && w.pvFoes.reduce((n, u) => n + u.hp, 0) > c.hp - 20))) c.follow = true; // 差個零頭不算打到
  if (c.follow && !me.act) me.input.target = foe;
}
function pvLoop(now) {
  // 只在選將畫面看得到時跑；開戰、切到別的分頁就停（回來時 renderChosen 會再叫起來）
  if (world || !pvCanvas.isConnected || !pvCanvas.offsetParent) { pvRaf = 0; return; }
  pvRaf = requestAnimationFrame(pvLoop);
  const dt = Math.max(0, Math.min(0.1, (now - pvLast) / 1000)); pvLast = now;
  const w = pvWorld;
  pvT += dt;
  if (pvT > pvNext && pvRows.length) playPreview((pvCur + 1) % pvRows.length, true);
  pvAcc += dt;
  while (pvAcc >= DT) { pvInput(); snapshot(w); w.step(DT); pvAcc -= DT; }
  const lerp = blend(w, Math.min(1, pvAcc / DT)), A = SG.Audio, me = w.player, foe = w.pvFoes[0] || me, cam = pvView.cam;
  cam.x += ((me.x + foe.x) / 2 - cam.x) * Math.min(1, dt * 4); cam.y += ((me.y + foe.y) / 2 - 40 - cam.y) * Math.min(1, dt * 4);
  SG.Audio = null; // 預覽不出聲
  try { pvView.frame(dt); } finally { SG.Audio = A; restore(lerp); }
}
// 謀略選擇（選將畫面、連線房間共用）：會員列出擁有的；訪客提示註冊
function mlPicker() {
  const own = Meta.mlOwned(), cur = Meta.mlChosen();
  if (!own.length) return `<div class="mlpick"><span class="k">謀略</span><span class="on-note"><a href="#" class="reg-link" data-reg="1">註冊</a>獲得第一個謀略「療傷」</span></div>`;
  return `<div class="mlpick"><span class="k">謀略</span>${own.map((id) => { const m = SG.ML[id]; return `<button type="button" class="mlb${id === cur ? ' on' : ''}" data-ml="${id}" title="${m.desc}　冷卻 ${m.cd} 秒"><img src="${SG.mlIconURL(id, 48)}" alt="" width="24" height="24">${m.name}</button>`; }).join('')}<span class="on-note">按 F 施放</span></div>`;
}
function bindMlPicker(box, redraw, onPick) { box.querySelectorAll('[data-ml]').forEach((b) => { b.onclick = () => { Meta.setMl(b.dataset.ml); if (onPick) onPick(b.dataset.ml); redraw(); }; }); }
SG.mlPicker = mlPicker; SG.bindMlPicker = bindMlPicker;
// 「註冊」連結（謀略區）：直接打開註冊視窗
document.addEventListener('click', (e) => { const a = e.target instanceof Element && e.target.closest('[data-reg]'); if (!a || !SG.Account) return; e.preventDefault(); SG.Account.open('register'); }); // 連線房間（net.ts）也用
// 說明裡的 {a/b/c} 只列 1 級的數字
const lv1 = (d) => d.replace(/\{([^}]+)\}/g, (_, g) => g.split('/')[0]);
// 名詞說明（「在水裡、濕」）：武將的技能有提到才列（heroes/define.ts SG.heroTerms）
const termsLi = (h) => SG.heroTerms(h).map((t) => `<li class="term"><kbd>註</kbd><div><b>${t.name}</b><br><span>${t.desc}</span></div></li>`).join('');
// 天賦（不佔技能格、1 級就有）：分段的數值全部列出
function talentLi(h) {
  const p = h.passive;
  if (!p) return '';
  return `<li class="tal"><kbd>天賦</kbd><div><b>${p.name}</b>（被動，不佔技能格）<br><span>${p.desc.replace(/\{([^}]+)\}/g, (_, g) => `<b class="tv">${g}</b>`)}${p.lv && p.lv.length > 1 ? `<small>　數值依序為 ${p.lv.join('／')} 級起</small>` : ''}</span></div></li>`;
}
function renderChosen() {
  const h = chosen, side = h.faction === 'wei' ? '魏軍（右上）' : '聯軍（左下）', L = SCHEMES[settings.scheme].labels, B = BATTLES[settings.battle];
  const box = $('chosen'); box.className = 'chosen show';
  box.innerHTML = `<div><h2>${h.name}</h2><div><span class="side" style="color:${h.faction === 'wei' ? 'var(--foe)' : 'var(--ally)'}">${FACTION[h.faction]} · ${side}</span>　<span style="color:var(--muted)">${SG.classOf(h)} · ${h.roleText} ｜ ${SG.rangeText(h)} ｜ ${SG.weaponText(h)}</span></div></div>
    <ul data-pv>${talentLi(h)}${SG.skillRows(h).map(({ i, s, tag }, r) => `<li data-r="${r}" title="點一下預覽"><kbd>${L[i]}</kbd><div>${tag ? `<small>${tag}</small> ` : ''}<b>${s.name}</b>${elTag(s)}${s.passive ? '（被動）' : '　<span>' + (SG.ARCH_NAMES[s.arch] || '') + '</span>'}<br><span>${lv1(s.desc)}</span>${s.then ? `<br><span class="st2">${SG.stageNote(s, lv1)}</span>` : ''}</div></li>`).join('')}${termsLi(h)}</ul>
    <div style="display:grid;gap:12px">${masteryBlock(h)}
    ${mlPicker()}
    <div class="golist"><button class="btn primary" type="button" id="go">出戰</button><span class="battle-tag">練習 · ${B.name} · ${B.size}v${B.size} · ${settings.mode === 'quick' ? '速戰' : '標準'}${h === Meta.dailyHero() ? ' · 今日武將' : ''}</span></div></div>`;
  $('go').addEventListener('click', () => { fullscreen(); start(h); });
  bindMlPicker(box, renderChosen);
  box.prepend(pvCanvas); setPreviewHero(pvSkinned(h)); // 預覽穿目前選的造型：萬聖造型的技能特效買之前就看得到
  const ul = box.querySelector('ul');
  ul.addEventListener('click', (e) => { const li = e.target.closest('li[data-r]'); if (li) playPreview(+li.dataset.r); });
  ul.addEventListener('mouseover', (e) => { const li = e.target.closest('li[data-r]'); if (li && +li.dataset.r !== pvCur) playPreview(+li.dataset.r); });
  bindSkins(box, h, renderChosen);
}
// 造型列：熟練度造型（未解鎖顯示條件）＋已購買的商域造型；點選即換上
function bindSkins(box, h, redraw) {
  const el = box.querySelector('.skins'); if (!el) return;
  el.addEventListener('click', (e) => {
    const b = e.target.closest('.skin'); if (!b) return;
    if (b.dataset.shop) { if (SG.Home) SG.Home.go('shop', { hero: h.id }); return; }
    if (b.dataset.try) { pvTry = { h: h.id, sk: b.dataset.v }; redraw(); return; } // 試看：預覽穿上，出戰照舊
    if (!b.classList.contains('locked')) { pvTry = null; Meta.setSkin(h.id, b.dataset.v); redraw(); }
  });
  el.querySelectorAll('.skin[data-v]').forEach((b) => portrait(b.querySelector('canvas'), Meta.skinned(h, b.dataset.v), 54));
}
// 還沒買的萬聖（傳說級）造型：活動期間在造型列可以試看
const canTry = (h, k) => !!(k.legend && k.heroes && k.heroes.includes(h.id) && Meta.activeEvents().some((e) => e.id === k.event));
function masteryBlock(h) {
  const rec = Meta.profile.heroes[h.id] || { xp: 0, games: 0, wins: 0, best: 0 }, m = Meta.masteryOf(rec.xp), cur = Meta.skinFor(h.id);
  return `<div class="mastery"><div>熟練度 <b>Lv${m.lv} ${m.name}</b>${rec.games ? `　${rec.games} 場 ${rec.wins} 勝 · 最佳 ${rec.best.toLocaleString()}` : '　尚未出戰'}</div>
    <div class="meter"><i style="--p:${m.frac.toFixed(3)}"></i></div>${m.next ? `<span>${rec.xp.toLocaleString()} / ${m.next.toLocaleString()}</span>` : ''}</div>
    <div class="opt"><b>造型</b><div class="skins">${Meta.SKINS.filter((k) => !k.price || Meta.skinUnlocked(h.id, k.id) || canTry(h, k)).map((k) => { const ok = Meta.skinUnlocked(h.id, k.id), tr = !ok && canTry(h, k); return `<button type="button" class="skin${ok ? '' : ' locked'}" data-v="${k.id}"${tr ? ' data-try="1"' : ''} aria-pressed="${tr ? !!(pvTry && pvTry.h === h.id && pvTry.sk === k.id) : k.id === cur && !(pvTry && pvTry.h === h.id)}" title="${k.desc}"><canvas aria-hidden="true"></canvas>${k.name}<small>${ok ? k.desc.slice(0, 8) : tr ? '試看・商域限定' : `熟練度 ${k.lv} 解鎖`}</small></button>`; }).join('')}<button type="button" class="skin" data-shop="1" title="到商域選購造型"><span style="font:900 26px/54px var(--display);color:var(--bronze)">＋</span>更多<small>商域選購</small></button></div></div>`;
}
renderGrid();

// ================= 遊戲 =================
let world = null, view = null, paused = false, last = 0, acc = 0, msgIdx = 0, running = false, endT = 0;
const keys = new Set(), touchKeys = new Set();
const mouse = { x: -1, y: -1, l: false, r: false };
let stick = [0, 0], aiming = null, touchMode = false, amoveArmed = false;
// 觸控拖曳瞄準：{ i 技能, p 瞄準點, moved 有沒有拖動, cancel 拖到取消區 }
let touchAim = null;

// 單機：直接開一局；連線大廳中：改為選定武將
function start(h) {
  // 人在連線房間裡就不開單機局（多人的武將在房間的選將階段選）
  if (SG.NET && SG.NET.inRoom()) { if (SG.Home) SG.Home.toast('你還在連線房間裡，先到大廳離開房間再練習'); return; }
  const sk = Meta.skinUnlocked(h.id, Meta.skinFor(h.id)) ? Meta.skinFor(h.id) : 'base';
  const B = BATTLES[settings.battle], hero = Meta.skinned(h, sk), bid = settings.battle;
  matchCtx = { battle: bid, dailyHero: h.id === Meta.dailyHero().id, challenge: bid === 'chibi' && challenge && challenge.hero.id === h.id && challenge.mode === settings.mode ? challenge : null };
  // 赤壁之戰走原本的單機開局；官渡、長坂坡用「一個真人座位，其餘電腦補滿」的方式開
  const ml = Meta.mlChosen(); // 謀略（訪客沒有）
  if (SG.CAMPAIGN) SG.CAMPAIGN.leave(); // 列傳地圖還在就先換回赤壁
  if (B.size === 5) begin(new SG.World({ hero, mode: settings.mode, ml }));
  else begin(new SG.World(Object.assign({ mode: settings.mode, slots: [{ spec: hero, team: h.faction === 'wei' ? 1 : 0, ml }] }, B.sim)));
}
let matchCtx = {};
SG.debugWorld = () => world; // 測試用
SG.debugView = () => view;
function begin(w) {
  $('select').hidden = true; $('end').hidden = true;
  $('game').hidden = false; $('hud').hidden = false;
  if (!w.campaign && SG.CAMPAIGN) SG.CAMPAIGN.leave(); // 連線對戰等：列傳地圖還在就先換回赤壁
  world = w;
  view = new SG.View($('game'), world, $('mini'));
  view.camLock = settings.cam === 'lock' || !!w.spectator; // 預設自由鏡頭（按住空白對準武將）；設定可改成鎖定武將；觀戰一律跟著選定的武將
  msgIdx = 0; paused = false; acc = 0; endT = 0;
  touchMode = !!(window.matchMedia && matchMedia('(pointer: coarse)').matches);
  document.body.classList.toggle('touch-ui', touchMode); // 觸控版面（CSS：body.touch-ui）
  SG.CAM_H = 0; // 手機也用「遠」（跟電腦一樣顯示 760）：v0.3.4 拿掉遠／中／近選項
  applyGfx(gfxProfile(touchMode)); fpsMon.slow = 0; hud.hk = null;
  touchAim = null;
  buildDock();
  if (!w.campaign) world.say(`目標：拆掉${world.player.team ? '左下的聯軍' : '右上的魏軍'}本營`, 'big');
  story.lines = []; story.lineT = 0; story.cardT = 0; $('cline').style.opacity = 0; $('ccard').classList.remove('on'); $('brief').hidden = true;
  $('touch').hidden = !touchMode; $('tpause').hidden = !!w.net; $('tpause').textContent = '停'; $('tcam').hidden = true;
  $('ios-tip').hidden = !(touchMode && IOS && !STANDALONE && Meta.tip('ios-home')); $('help').hidden = touchMode;
  $('guide').innerHTML = `<div class="gd-box"><header><h3>操作指南</h3><span>滑鼠 MOBA 操作　·　按 <kbd class="kc">H</kbd> 或 <kbd class="kc">Esc</kbd> 關閉</span></header>${guideHTML()}</div>`;
  // 第一次玩：開局先攤開指南（之後只在左上角留一顆小提示）
  $('guide').hidden = touchMode || !Meta.tip('guide');
  $('guide').onclick = (e) => { if (!e.target.closest('.gd-box')) $('guide').hidden = true; }; // 點外圍就關掉
  aiming = null; mouse.x = mouse.y = -1;
  if (!running) { running = true; last = performance.now(); requestAnimationFrame(loop); }
}

// ---------- 畫面插值 ----------
// 每步模擬前記下位置；畫之前暫時把座標換成插值位置，畫完再換回來（模擬層看到的永遠是真實座標）
const prevPos = new WeakMap();
function snapshot(w) {
  for (const u of w.units) prevPos.set(u, [u.x, u.y]);
  for (const p of w.projs) prevPos.set(p, [p.x, p.y]);
}
function blend(w, a) {
  const saved = [];
  const one = (o) => {
    const q = prevPos.get(o);
    if (!q || (q[0] === o.x && q[1] === o.y)) return;
    if (Math.abs(o.x - q[0]) + Math.abs(o.y - q[1]) > 160) return; // 瞬移、復活、回城：不要拖過去
    saved.push(o, o.x, o.y);
    o.x = q[0] + (o.x - q[0]) * a; o.y = q[1] + (o.y - q[1]) * a;
  };
  for (const u of w.units) one(u);
  for (const p of w.projs) one(p);
  return saved;
}
function restore(saved) { for (let i = 0; i < saved.length; i += 3) { saved[i].x = saved[i + 1]; saved[i].y = saved[i + 2]; } }

function loop(now) {
  // 先排下一幀：這一幀裡任何介面例外（例如商店）都不該讓整個遊戲停住
  requestAnimationFrame(loop);
  // 省電畫質：限制每秒 30 幀（太早的這一幀直接跳過，模擬靠累積時間追上）
  const cap = SG.GFX && SG.GFX.fps;
  if (cap && world && now - last < 1000 / cap - 2) return;
  if (view && world && view.me !== world.player) view.me = world.player; // 列傳劇情換了操作的武將：鏡頭與介面跟著換
  // 下限 0：開局建場景較久時，第一幀的時間戳可能早於 begin() 記下的時間，負的 dt 會讓模擬卡住好幾秒
  const dt = Math.max(0, Math.min(0.1, (now - last) / 1000)); last = now;
  // 自動畫質：連續兩次 3 秒平均低於 40 FPS 就降一步：先把解析度降到 1 倍，還是卡才鎖 30 FPS（光影一律保留）
  if (world && SG.GFX && SG.GFX.auto && !paused) {
    fpsMon.t += dt; if (fpsMon.t > 0) fpsMon.n++;
    if (fpsMon.t >= 3) {
      const fps = fpsMon.n / fpsMon.t; fpsMon.t = 0; fpsMon.n = 0;
      fpsMon.slow = fps < 40 ? fpsMon.slow + 1 : 0;
      if (fpsMon.slow >= 2) {
        fpsMon.slow = 0;
        if (SG.GFX.dpr > 1) applyGfx(Object.assign({}, SG.GFX, { dpr: 1 }));
        else if (!SG.GFX.fps || SG.GFX.fps > 30) { applyGfx(Object.assign({}, SG.GFX, { fps: 30, auto: false })); world.say('畫面不夠順，已鎖定每秒 30 幀（設定頁可以改畫質）', 'info'); }
      }
    }
  }
  if (world) {
    if (world.net) world.net.update(dt, readInput);
    else if (!paused && world.over === null) {
      // 頓幀與慢動作：view 決定這一幀的時間倍率
      const k = view.timeScale(dt); view.lastK = k;
      acc += dt * k;
      while (acc >= DT) { readInput(); snapshot(world); world.step(DT); acc -= DT; }
    }
    if (world.over !== null) { endT += dt; view.lastK = 0.3; }
    // 模擬每秒 30 步，畫面每秒 60～120 幀：畫的時候把單位與投射物放在前後兩步之間，移動才順
    const lerp = !world.net && !paused ? blend(world, Math.min(1, acc / DT)) : null;
    view.frame(paused ? 0 : world.over !== null ? dt * 0.3 : dt * (view.lastK || 1));
    if (lerp) restore(lerp);
    hud(dt);
    if (world.over !== null && $('end').hidden && (endT > 2.8 || world.net)) showEnd();
  }
}

// ---------- 輸入 ----------
const USED = new Set(['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Space', 'Tab', 'KeyQ', 'KeyW', 'KeyE', 'KeyR', 'KeyF', 'KeyA', 'KeyS', 'KeyD', 'KeyZ', 'KeyX', 'KeyC', 'KeyY', 'KeyB', 'KeyP', 'Escape', 'ShiftLeft', 'ShiftRight', 'KeyH', 'KeyG', 'KeyM',
  'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6']);
const hostile = (u) => u && (u.team !== world.player.team || world.canDeny(world.player, u));
const aimWorld = () => (mouse.x < 0 ? [world.player.x + world.player.f * 200, world.player.y] : view.toWorld(mouse.x, mouse.y));
// 鍵盤經典與觸控：朝前方最近的可見敵方武將，沒有就朝面向
function autoAim(i) {
  const me = world.player, R = (world.skillRange(SG.skillAt(me, i), me.skillLv[i]) || 300) + 120;
  let best = null, bd = 1e9;
  for (const u of world.units) {
    if (u.kind !== 'hero' || !world.isEnemy(me, u)) continue;
    const d = SG.gd(me.x, me.y, u.x, u.y);
    if (d < R && d < bd && (touchMode || (u.x - me.x) * me.f > -20)) { bd = d; best = u; }
  }
  return best ? [best.x, best.y] : [me.x + me.f * 200, me.y];
}
// 指定單體技能的目標：游標正下方的單位，否則游標 110 內最近的（治療類優先友軍，其餘優先敵人、武將優先）
function unitTarget(i, p = aimWorld()) {
  const me = world.player, sk = SG.skillAt(me, i);
  const allyFirst = sk.arch === 'heal' || (sk.x && (sk.x.allyFirst || sk.x.k === 'pullally'));
  const selfOk = !!(sk.x && sk.x.selfOk); // 可以點自己（劉備「聖光術」）
  const ward = (u) => sk.wardHop && u.kind === 'ward' && u.team === me.team && !u.owl; // 跳眼：可以點自己的眼（斥候旗等）
  const ok = (u) => u && u.alive && (u !== me || selfOk) && !u.structure && (u.kind !== 'ward' || ward(u)) && (u.team === me.team ? true : u.vis ? u.vis[me.team] !== false : true);
  const under = view.pick(p[0], p[1]);
  if (ok(under)) return under;
  let best = null, bd = 1e9;
  for (const u of world.units) {
    if (!ok(u)) continue;
    const d = SG.gd(p[0], p[1], u.x, u.y);
    if (d > 110) continue;
    const pref = (allyFirst ? (u.team === me.team ? 0 : 200) : (hostile(u) ? 0 : 200)) + (u.kind === 'hero' ? 0 : 60) - (u.kind === 'ward' ? 140 : 0); // 眼排在敵人後面、友軍前面
    if (d + pref < bd) { bd = d + pref; best = u; }
  }
  return best;
}
function castSkill(i) {
  const me = world.player, sk = SG.skillAt(me, i);
  if (!sk) return false;
  if (sk.passive) { world.say(`${sk.name} 是被動技能`, 'warn'); return false; }
  const auto = settings.scheme === 'classic' || touchMode;
  if (auto && SG.aimOf(sk, me.skillLv[i]).kind === 'unit') { // 觸控點一下：自動鎖定一個目標（點擊技必中）
    const t = unitTarget(i, autoAim(i));
    if (!t) { world.tell(me, `${sk.name} 附近沒有目標`, 'warn'); return false; }
    me.input.skill = { i, x: t.x, y: t.y, tid: t.id };
    return true;
  }
  if (!auto && SG.aimOf(sk, me.skillLv[i]).kind === 'unit') {
    const t = unitTarget(i);
    if (!t) { world.tell(me, `${sk.name} 要點選一個目標`, 'warn'); return false; }
    me.input.skill = { i, x: t.x, y: t.y, tid: t.id };
    return true;
  }
  const p = auto ? autoAim(i) : aimWorld();
  me.input.skill = { i, x: p[0], y: p[1] };
  return true;
}
// 謀略（v0.3.0）：F 鍵／按鈕。電腦：指定敵將用游標下的（沒有就游標附近最近的）、地點用游標；觸控：自動
function castMl() {
  const me = world.player, m = me.ml && SG.ML[me.ml];
  if (!m) { world.say('沒有帶謀略：註冊會員即送「療傷」', 'warn'); return; }
  if (me.mlCd > 0) { world.say(`${m.name} 冷卻中（${Math.ceil(me.mlCd)} 秒）`, 'warn'); return; }
  if (m.aim === 'self') { me.input.ml = {}; return; }
  if (touchMode) {
    if (m.aim === 'unit') me.input.ml = {};
    else if (m.id === 'flash') { const d = Math.hypot(stick[0], stick[1]) > 0.2 ? stick : [me.f, 0]; me.input.ml = { x: me.x + d[0] * 600, y: me.y + d[1] * 600 * SG.K }; }
    else { const [x0, y0] = view.view; me.input.ml = { x: x0 + innerWidth / 2 / view.zoom, y: y0 + innerHeight / 2 / view.zoom }; } // 支援：畫面中央附近（先用小地圖把鏡頭移過去）
    buzz(12); return;
  }
  const p = aimWorld(), u = view.hover && hostile(view.hover) && view.hover.kind === 'hero' ? view.hover : null;
  me.input.ml = { x: p[0], y: p[1], tid: u ? u.id : undefined };
}
function skillDown(i) {
  const sk = SG.skillAt(world.player, i);
  if (!sk) return;
  if (sk.passive) { world.say(`${sk.name} 是被動技能`, 'warn'); return; }
  const A = SG.aimOf(sk, world.player.skillLv[i]);
  if (A.kind === 'self' || settings.scheme === 'classic' || touchMode) castSkill(i);
  else { aiming = i; view.indicator = { i }; } // 點擊施放：顯示範圍，等左鍵點地面（右鍵或 Esc 取消）
}
const stopAim = () => { aiming = null; if (view) view.indicator = null; };
// S：停下來，並中止攻擊狀態（v0.3.8：攻擊狀態只有 S 會結束；防禦、移動、施法結束後都回到攻擊）
function stopOrder(I) { I.moveTo = null; I.target = null; I.amove = null; I.engageReq = false; I.wpAdd = null; I.stop = true; I.hard = true; if (view) view.wps = []; }
// Shift＋右鍵：在路徑最後追加一個點（像世紀帝國）；一般右鍵、A、S 會清掉路徑
function addWaypoint(p) {
  const I = world.player.input;
  if (!view.wps.length) I.wpClr = true; // 沒有排過路徑：這一點取代目前的移動
  I.wpAdd = (I.wpAdd || []).concat([p]); I.target = null; I.amove = null; I.disengage = true; I.hard = true;
  if (!view.wps.length) I.moveTo = null;
  view.wps.push(p); view.mark(p[0], p[1]);
}
function order(p) {
  const I = world.player.input, u = view.pick(p[0], p[1]);
  I.wpClr = true; I.wpAdd = null; view.wps = hostile(u) ? [] : [p];
  if (hostile(u)) { I.target = u; I.engageReq = true; I.moveTo = null; view.mark(u.x, u.y, '#ff5a5a'); } // 右鍵點敵人：進入攻擊狀態
  else { I.moveTo = p; I.target = null; I.disengage = true; view.mark(p[0], p[1]); } // 右鍵移動：結束攻擊狀態（曹彰上馬時例外，模擬端判斷）
  I.amove = null; I.hard = true;
}

window.addEventListener('keydown', (e) => {
  if (!world || !$('select').hidden) return;
  if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return; // 正在打字（聊天）時不當成操作
  const code = e.code, sc = settings.scheme, I = world.player.input;
  if (USED.has(code)) e.preventDefault();
  if (e.repeat) return;
  keys.add(code);
  if (code === 'KeyP') return toggleShop();
  if (code === 'KeyB') { I.recall = true; if (!$('shop').hidden) toggleShop(); return; }
  if (code === 'Space') { if (!view.camHold) { view.camHold = true; view.camPrev = view.camLock; } return; }
  if (code === 'KeyH') { $('guide').hidden = !$('guide').hidden; return; }
  if (code === 'KeyM' && SG.Audio) { SG.Audio.set('music', !SG.Audio.settings.music); world.say(SG.Audio.settings.music ? '背景音樂：開' : '背景音樂：關', 'info'); return; }
  if (code === 'Tab') return showBoard(true);
  if (code === 'KeyG') { openWheel(); return; }
  if (code === 'Escape') {
    if (!$('guide').hidden) { $('guide').hidden = true; return; }
    if (wheel) { closeWheel(); return; }
    if (amoveArmed) { amoveArmed = false; return; }
    if (aiming !== null) return stopAim();
    if (insp) { insp = null; renderInspect(); return; }
    if (!$('shop').hidden) return toggleShop();
    if (world.net) return; setPaused(!paused); return;
  }
  if (/^Digit[1-6]$/.test(code)) { I.item = +code.slice(5) - 1; return; }
  if (code === 'KeyO') { I.learn = 4; return; }
  const si = SCHEMES[sc].skillKeys.indexOf(code);
  if (si >= 0) { if (e.altKey || e.ctrlKey) { I.learn = si; return; } return skillDown(si); }
  if (sc === 'moba') {
    if (code === 'KeyF') { castMl(); return; } // 謀略
    if (code === 'KeyA') { amoveArmed = true; stopAim(); } // 行動攻擊：按 A 之後再左鍵點地面或敵人才觸發
    else if (code === 'KeyS') stopOrder(I); // 停止：唯一能中止攻擊狀態的指令
    else if (code === 'KeyY') { view.camLock = !view.camLock; world.say(view.camLock ? '鏡頭：跟隨武將' : '鏡頭：自由（游標靠邊捲動，Y 切回）', 'info'); }
  }
});
window.addEventListener('keyup', (e) => {
  keys.delete(e.code);
  if (!world) return;
  if (e.code === 'Tab') showBoard(false);
  if (e.code === 'KeyG') pickWheel();
  if (e.code === 'Space') releaseCam();
  const si = SCHEMES[settings.scheme].skillKeys.indexOf(e.code);
  if (si >= 0 && aiming === si && settings.cast === 'hold') { castSkill(si); stopAim(); } // 指定單體放開時沒點到目標：取消（會提示）
});
// 放開空白：滑鼠 MOBA 回到自由鏡頭（游標靠邊捲動），其他操作方式回到原本的跟隨
function releaseCam() { if (!view || !view.camHold) return; view.camHold = false; view.camLock = view.camPrev; }
window.addEventListener('blur', () => { keys.clear(); mouse.l = mouse.r = false; stopAim(); releaseCam(); });

const cv = $('game');
cv.addEventListener('contextmenu', (e) => e.preventDefault());
window.addEventListener('mousemove', (e) => { mouse.x = e.clientX; mouse.y = e.clientY; });
// 觸控：點戰場上的敵人＝鎖定為優先攻擊目標（手指比游標粗，找點擊處 90 內最近的敵人）；移動交給搖桿
// 觸控：在戰場上拖曳一根手指＝平移鏡頭（看別的地方；「回到武將」或推搖桿回來）
let fieldPan = null;
cv.addEventListener('pointermove', (e) => {
  if (!fieldPan || e.pointerId !== fieldPan.id) return;
  const dx = e.clientX - fieldPan.x, dy = e.clientY - fieldPan.y;
  if (!fieldPan.on && Math.hypot(dx, dy) < 12) return;
  if (!fieldPan.on) { fieldPan.on = true; view.camLock = false; $('tcam').hidden = false; }
  view.cam.x = fieldPan.cx - dx / view.zoom; view.cam.y = fieldPan.cy - dy / view.zoom;
});
const endPan = (e) => { if (fieldPan && e.pointerId === fieldPan.id) fieldPan = null; };
cv.addEventListener('pointerup', endPan); cv.addEventListener('pointercancel', endPan);
cv.addEventListener('pointerdown', (e) => {
  if (!world || world.over !== null || !touchMode) return;
  e.preventDefault();
  fieldPan = { id: e.pointerId, x: e.clientX, y: e.clientY, cx: view.cam.x, cy: view.cam.y, on: false };
  if (!world.player.alive) return;
  const p = view.toWorld(e.clientX, e.clientY), me = world.player;
  let best = null, bd = 90;
  for (const u of world.units) {
    if (!hostile(u) || u.kind === 'ward') continue;
    const d = SG.gd(p[0], p[1], u.x, u.y - (u.structure ? 60 : 30)) - (u.r || 20);
    if (d < bd) { bd = d; best = u; }
  }
  if (!best) return;
  const I = me.input; I.target = best; I.engageReq = true; I.moveTo = null; I.amove = null; I.hard = true;
  view.mark(best.x, best.y, '#ff5a5a'); buzz(10);
});
cv.addEventListener('mousedown', (e) => {
  if (!world || world.over !== null || touchMode) return; // 觸控走上面的 pointerdown（點擊也會補送相容的滑鼠事件）
  mouse.x = e.clientX; mouse.y = e.clientY;
  const I = world.player.input, p = aimWorld();
  if (e.button === 2) {
    mouse.r = true;
    if (amoveArmed) { amoveArmed = false; return; } // 右鍵取消行動攻擊
    if (aiming !== null) return stopAim(); // 右鍵取消瞄準
    if (settings.scheme === 'moba') { const u = view.pick(p[0], p[1]); if (e.shiftKey && !hostile(u)) addWaypoint(p); else order(p); }
  } else if (e.button === 0) {
    mouse.l = true;
    if (wheel) { pickWheel(); return; }
    if (e.altKey || e.ctrlKey) { const u = view.pick(p[0], p[1]); sendPing(e.ctrlKey ? 'danger' : hostile(u) ? 'attack' : 'go', p[0], p[1], hostile(u) ? u : null); return; }
    if (aiming !== null) { if (castSkill(aiming)) stopAim(); return; } // 點擊施放：點空地不取消，繼續瞄準
    if (world.player.grab) { I.punch = true; return; }
    if (amoveArmed) { // 行動攻擊：點敵人就打它；點地面就走過去，途中遇到敵人主動攻擊，打完繼續走
      amoveArmed = false;
      const u = view.pick(p[0], p[1]);
      if (hostile(u)) { I.target = u; I.amove = null; view.mark(u.x, u.y, '#ff5a5a'); }
      else { I.amove = p; I.target = null; view.mark(p[0], p[1], '#ff5a5a'); }
      I.engageReq = true; I.moveTo = null; I.hard = true; I.wpClr = true; I.wpAdd = null; view.wps = []; return;
    }
    if (settings.scheme === 'moba') {
      // v0.3.8：左鍵點單位＝查看它的狀態與技能（不再是普攻）；按住空地拖曳畫面，點一下空地收起
      const u = view.pick(p[0], p[1]);
      if (u) { insp = u; renderInspect(); }
      else drag = { x: e.clientX, y: e.clientY, cx: view.cam.x, cy: view.cam.y, moved: false };
    }
  }
});
// 滑鼠 MOBA：左鍵拖曳移動鏡頭（拖動後鏡頭變自由，按住空白回到武將）
let drag = null;
window.addEventListener('mousemove', (e) => {
  if (!drag || !view) return;
  const dx = (e.clientX - drag.x) / view.zoom, dy = (e.clientY - drag.y) / view.zoom;
  if (!drag.moved && Math.abs(dx) + Math.abs(dy) < 6) return;
  drag.moved = true; view.camLock = false;
  view.cam.x = drag.cx - dx; view.cam.y = drag.cy - dy;
  cv.style.cursor = 'grabbing';
});
window.addEventListener('mouseup', (e) => { if (e.button === 2) mouse.r = false; if (e.button === 0) { mouse.l = false; if (drag && !drag.moved && insp) { insp = null; renderInspect(); } drag = null; } });
const mini = $('mini');
mini.addEventListener('contextmenu', (e) => e.preventDefault());
// 觸控：點一下＝鏡頭跳過去（出現「回到武將」）；長按＝在那裡發「注意這裡」訊號
// 小地圖（觸控）：按住拖曳＝鏡頭跟著手指看，放開回到武將；點一下＝鏡頭跳過去停著（「回到武將」回來）；長按不動＝發訊號
let miniHold = null;
const miniAt = (e) => { const r = mini.getBoundingClientRect(); return [((e.clientX - r.left) / r.width) * SG.MAP.W, ((e.clientY - r.top) / r.height) * SG.MAP.H]; };
mini.addEventListener('pointerdown', (e) => {
  if (!world || !touchMode) return;
  e.preventDefault(); mini.setPointerCapture(e.pointerId);
  const [wx, wy] = miniAt(e);
  miniHold = { wx, wy, sx: e.clientX, sy: e.clientY, pan: false, t: setTimeout(() => { if (miniHold && !miniHold.pan) { miniHold = null; sendPing('go', wx, wy, null); buzz(25); } }, 500) };
});
mini.addEventListener('pointermove', (e) => {
  if (!miniHold) return;
  if (!miniHold.pan && Math.hypot(e.clientX - miniHold.sx, e.clientY - miniHold.sy) > 6) { miniHold.pan = true; clearTimeout(miniHold.t); }
  if (miniHold.pan) { const [wx, wy] = miniAt(e); view.camLock = false; view.cam.x = wx; view.cam.y = wy; }
});
mini.addEventListener('pointerup', () => {
  if (!miniHold) return;
  clearTimeout(miniHold.t);
  if (miniHold.pan) { view.camLock = true; $('tcam').hidden = true; } // 拖著看完：放開回到武將
  else { view.camLock = false; view.cam.x = miniHold.wx; view.cam.y = miniHold.wy; $('tcam').hidden = false; }
  miniHold = null;
});
mini.addEventListener('pointercancel', () => { if (miniHold) { clearTimeout(miniHold.t); miniHold = null; } });
$('tcam').addEventListener('click', () => { if (view) view.camLock = true; $('tcam').hidden = true; });
$('tminit').addEventListener('click', () => { document.body.classList.toggle('mini-off'); });
$('ios-tip-x').addEventListener('click', () => { $('ios-tip').hidden = true; });
$('tattr').addEventListener('pointerdown', (e) => { e.preventDefault(); if (world) { world.player.input.learn = 4; buzz(10); } });
$('tml').addEventListener('pointerdown', (e) => { e.preventDefault(); if (world) castMl(); });
// Android：對戰中只要被退出全螢幕（切 App、下拉通知），下一次觸控就重新進入
$('touch').addEventListener('pointerdown', () => { if (touchMode && !IOS && !document.fullscreenElement) fullscreen(); }, true);
mini.addEventListener('mousedown', (e) => {
  if (!world || touchMode) return; // 觸控用上面的 pointer 處理（避免相容滑鼠事件再觸發一次）
  e.preventDefault();
  const r = mini.getBoundingClientRect(), wx = ((e.clientX - r.left) / r.width) * SG.MAP.W, wy = ((e.clientY - r.top) / r.height) * SG.MAP.H;
  if (e.button === 0 && (e.altKey || e.ctrlKey)) { sendPing(e.ctrlKey ? 'danger' : 'go', wx, wy, null); return; }
  if (e.button === 2) { const I = world.player.input; if (e.shiftKey) { addWaypoint([wx, wy]); return; } I.moveTo = [wx, wy]; I.target = null; I.disengage = true; I.hard = true; I.wpClr = true; I.wpAdd = null; view.wps = [[wx, wy]]; view.mark(wx, wy); }
  else { view.camLock = false; view.cam.x = wx; view.cam.y = wy; world.say('鏡頭：自由（Y 切回跟隨）', 'info'); }
});

// ---------- 隊伍訊號（ping）：Alt／Ctrl＋左鍵、按住 G 開輪盤；連線時只送給隊友 ----------
const WHEEL = [['gather', -Math.PI / 2], ['otw', 0], ['danger', Math.PI / 2], ['miss', Math.PI]]; // 上、右、下、左
let wheel = null, pingTimes = [];
function openWheel() {
  if (!world || !view || mouse.x < 0 || wheel) return;
  const el = document.createElement('div'); el.className = 'ping-wheel';
  el.style.left = mouse.x + 'px'; el.style.top = mouse.y + 'px';
  el.innerHTML = WHEEL.map(([k, a]) => { const d = SG.PINGS[k]; return `<span data-k="${k}" style="--x:${Math.cos(a) * 74}px;--y:${Math.sin(a) * 74}px;--c:${d.col}"><b>${d.ch}</b>${d.name}</span>`; }).join('') + '<i></i>';
  document.body.appendChild(el);
  wheel = { el, x: mouse.x, y: mouse.y, w: view.toWorld(mouse.x, mouse.y), sel: null };
  wheel.move = (e) => {
    const dx = e.clientX - wheel.x, dy = e.clientY - wheel.y;
    wheel.sel = Math.hypot(dx, dy) < 22 ? null : WHEEL.reduce((b, [k, a]) => { const d = Math.abs(Math.atan2(Math.sin(Math.atan2(dy, dx) - a), Math.cos(Math.atan2(dy, dx) - a))); return d < b[1] ? [k, d] : b; }, [null, 9])[0];
    el.querySelectorAll('span').forEach((s) => s.classList.toggle('on', s.dataset.k === wheel.sel));
  };
  window.addEventListener('mousemove', wheel.move);
}
function closeWheel() { if (!wheel) return; window.removeEventListener('mousemove', wheel.move); wheel.el.remove(); wheel = null; }
function pickWheel() { if (!wheel) return; const w = wheel; closeWheel(); sendPing(w.sel || 'go', w.w[0], w.w[1], null); }
function sendPing(k, x, y, target) {
  if (!world || !SG.PINGS[k]) return;
  const now = performance.now();
  pingTimes = pingTimes.filter((t) => now - t < 4000);
  if (pingTimes.length >= 3) { world.say('訊號太頻繁，稍等一下', 'warn'); return; }
  pingTimes.push(now);
  const me = world.player, o = { k, x: Math.round(x), y: Math.round(y), uid: target ? target.id : null, name: me.spec ? me.spec.name : '' };
  showPing(o);
  if (world.net && SG.NET && SG.NET.ping) SG.NET.ping(o);
}
function showPing(o) {
  if (!view || !view.ping) return;
  view.ping(o);
  const d = SG.PINGS[o.k];
  if (world) world.say(`${o.name ? o.name + '：' : ''}${d.name}`, 'info');
  if (SG.Audio) SG.Audio.play(o.k === 'danger' ? 'gong' : 'chime');
}

let moveHeld = 0;
function readInput() {
  const me = world.player, I = me.input, sc = settings.scheme, k = (c) => keys.has(c);
  const useMouse = sc !== 'classic' && !touchMode && mouse.x >= 0;
  const aim = useMouse ? aimWorld() : null;
  I.aim = aim || [me.x + me.f * 200, me.y];
  view.aim = aim || I.aim;
  view.hover = aim ? view.pick(aim[0], aim[1]) : null;
  view.aimUnit = aiming !== null && aim && SG.aimOf(SG.skillAt(me, aiming), me.skillLv[aiming]).kind === 'unit' ? unitTarget(aiming) : null;
  if (touchAim) { // 觸控拖曳瞄準：瞄準點由拖曳方向決定
    view.aim = touchAim.p; view.indicator = touchAim.cancel ? null : { i: touchAim.i };
    view.aimUnit = SG.aimOf(SG.skillAt(me, touchAim.i), me.skillLv[touchAim.i]).kind === 'unit' ? unitTarget(touchAim.i, touchAim.p) : null;
  }
  cv.style.cursor = drag && drag.moved ? 'grabbing' : amoveArmed || (view.hover && hostile(view.hover)) ? 'crosshair' : 'default';
  let mx = 0, my = 0;
  if (sc === 'moba') {
    I.defend = k('KeyD'); // v0.3.0：S 停止、A 攻擊、D 防禦（按住）
    I.attack = false;
    // 按住右鍵持續移動（每 0.1 秒更新一次目的地）
    I.wpShow = view.wps; // 連線預測用（客戶端看不到伺服器那邊的路徑佇列）
    if (view.wps.length && (!me.alive || SG.gd(me.x, me.y, view.wps[0][0], view.wps[0][1]) < 24)) { if (me.alive) view.wps.shift(); else view.wps = []; } // 路徑點走到就收起
    if (mouse.r && aiming === null && aim && !k('ShiftLeft') && !k('ShiftRight') && (moveHeld += DT) > 0.1) {
      moveHeld = 0;
      const u = view.pick(aim[0], aim[1]);
      if (!hostile(u)) { I.moveTo = aim; I.target = null; I.disengage = true; I.cancel = true; view.wps = [aim]; }
    }
    const cw = cv.clientWidth, chh = cv.clientHeight;
    view.pan = !view.camLock && mouse.x >= 0 ? [mouse.x < 18 ? -1 : mouse.x > cw - 18 ? 1 : 0, mouse.y < 18 ? -1 : mouse.y > chh - 18 ? 1 : 0] : [0, 0];
  } else if (sc === 'wasd') {
    mx = (k('KeyD') ? 1 : 0) - (k('KeyA') ? 1 : 0); my = (k('KeyS') ? 1 : 0) - (k('KeyW') ? 1 : 0);
    I.attack = mouse.l && aiming === null;
    I.defend = k('ShiftLeft') || k('ShiftRight') || (mouse.r && aiming === null);
  } else {
    mx = (k('ArrowRight') ? 1 : 0) - (k('ArrowLeft') ? 1 : 0); my = (k('ArrowDown') ? 1 : 0) - (k('ArrowUp') ? 1 : 0);
    I.attack = k('KeyZ'); I.defend = k('KeyC');
  }
  if (touchMode) {
    if (Math.hypot(stick[0], stick[1]) > 0.2) { mx = stick[0]; my = stick[1]; }
    I.attack = I.attack || touchKeys.has('Z'); I.defend = I.defend || touchKeys.has('C');
  }
  if (mx || my) { I.mx = mx; I.my = my; I.moveTo = null; I.target = null; I.disengage = true; I.cancel = true; } // 搖桿移動＝右鍵移動：結束攻擊狀態（按住「攻」會再進入）
  else { I.mx = 0; I.my = 0; }
}

// 觸控
const stickEl = $('stick'), knob = stickEl.querySelector('i');
let sid = null;
const smove = (e) => {
  const r = stickEl.getBoundingClientRect();
  let dx = (e.clientX - r.left - r.width / 2) / (r.width / 2), dy = (e.clientY - r.top - r.height / 2) / (r.height / 2);
  const m = Math.hypot(dx, dy); if (m > 1) { dx /= m; dy /= m; }
  stick = [dx, dy]; knob.style.setProperty('--dx', dx * 36 + 'px'); knob.style.setProperty('--dy', dy * 36 + 'px');
  if (view && !view.camLock && Math.hypot(dx, dy) > 0.3) { view.camLock = true; $('tcam').hidden = true; } // 一推搖桿：鏡頭回到武將
};
stickEl.addEventListener('pointerdown', (e) => { sid = e.pointerId; stickEl.setPointerCapture(sid); smove(e); });
stickEl.addEventListener('pointermove', (e) => { if (e.pointerId === sid) smove(e); });
const send = () => { sid = null; stick = [0, 0]; knob.style.setProperty('--dx', '0px'); knob.style.setProperty('--dy', '0px'); };
stickEl.addEventListener('pointerup', send); stickEl.addEventListener('pointercancel', send);
// 小功能鍵：防（按住）、回城、商店、戰況、屬性加強
document.querySelectorAll('#tbtns button').forEach((b) => {
  const k = b.dataset.k;
  b.addEventListener('pointerdown', (e) => {
    e.preventDefault();
    if (!world) return;
    buzz(8);
    if (k === 'P') return toggleShop();
    if (k === 'B') { world.player.input.recall = true; return; }
    if (k === 'Tab') return showBoard($('board').hidden);
    if (k === 'Esc') { if (!world.net) setPaused(!paused); return; }
    if (k === 'S') { stopOrder(world.player.input); return; } // 止：中止攻擊狀態
    touchKeys.add(k); b.classList.add('on');
  });
  const up = () => { touchKeys.delete(k); b.classList.remove('on'); };
  b.addEventListener('pointerup', up); b.addEventListener('pointerleave', up); b.addEventListener('pointercancel', up);
});
// 普攻鍵、防禦鍵：按住持續攻擊／防禦
for (const [sel, k] of [['.tatk', 'Z'], ['.tdef', 'C']]) {
  const el = document.querySelector(sel);
  el.addEventListener('pointerdown', (e) => { e.preventDefault(); if (!world) return; buzz(8); touchKeys.add(k); el.classList.add('on'); });
  const up = () => { touchKeys.delete(k); el.classList.remove('on'); };
  el.addEventListener('pointerup', up); el.addEventListener('pointerleave', up); el.addEventListener('pointercancel', up);
}
// 技能鍵：點一下＝自動瞄準最近的敵將施放；按住拖曳＝瞄準方向與距離，放開施放；拖到上方「取消」放開＝不施放；右上的＋＝升級
const TDRAG = 90; // 拖曳多遠算最大射程（px）
function touchAimAt(i, dx, dy) {
  const me = world.player, sk = SG.skillAt(me, i), A = SG.aimOf(sk, me.skillLv[i]);
  const R = world.skillRange(sk, me.skillLv[i]) || A.area || 200, L = Math.hypot(dx, dy);
  const dir = SG.dirTo({ x: 0, y: 0 }, dx, dy), d = A.kind === 'dir' || A.kind === 'cone' ? R : Math.min(1, L / TDRAG) * R;
  return SG.along(me.x, me.y, dir, Math.max(30, d));
}
function bindTouchSkills() {
  const box = $('tskills');
  box.querySelectorAll('.tsk').forEach((b) => {
    const i = +b.dataset.s;
    let start = null, pid = null;
    b.querySelector('.up').addEventListener('pointerdown', (e) => { e.preventDefault(); e.stopPropagation(); if (world) { world.player.input.learn = i; buzz(10); } });
    let tipT = 0, tipped = false;
    // 長按（不動）0.45 秒：顯示技能說明，放開不施放（v0.3.4）
    const holdTip = () => { clearTimeout(tipT); tipped = false; tipT = setTimeout(() => { if (touchAim && touchAim.moved) return; tipped = true; buzz(12); showTip(i, b); placeTouchTip(b); if (touchAim) touchAim.cancel = true; }, 450); };
    b.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      if (!world || !world.player.alive) return;
      const me = world.player, sk = SG.skillAt(me, i);
      holdTip();
      pid = e.pointerId; b.setPointerCapture(pid); start = [e.clientX, e.clientY];
      if (sk.passive || !me.skillLv[i]) { touchAim = { i, p: null, moved: false, cancel: false, info: true }; return; } // 被動、沒學：只能長按看說明
      buzz(8);
      touchAim = { i, p: autoAim(i), moved: false, cancel: false };
      SG.aimRange = world.skillRange(sk, me.skillLv[i]) || 0; // 鏡頭自動拉遠到看得見施放範圍
      b.classList.add('aiming');
    });
    b.addEventListener('pointermove', (e) => {
      if (e.pointerId !== pid || !touchAim) return;
      const dx = e.clientX - start[0], dy = e.clientY - start[1];
      if (!touchAim.moved && Math.hypot(dx, dy) < 14) return;
      if (touchAim.info || tipped) return;
      const A0 = SG.aimOf(SG.skillAt(world.player, i), world.player.skillLv[i]); if (A0.kind === 'self' || SG.skillAt(world.player, i).tg) return; // 自身技能不用瞄
      if (!touchAim.moved) { touchAim.moved = true; clearTimeout(tipT); $('tcancel').hidden = false; }
      touchAim.p = touchAimAt(i, dx, dy);
      const c = $('tcancel').getBoundingClientRect(), hot = e.clientX > c.left - 20 && e.clientX < c.right + 20 && e.clientY > c.top - 20 && e.clientY < c.bottom + 20;
      if (hot !== touchAim.cancel) { touchAim.cancel = hot; $('tcancel').classList.toggle('hot', hot); if (hot) buzz(15); }
    });
    const end = (e, ok) => {
      if (e.pointerId !== pid) return;
      pid = null; b.classList.remove('aiming'); $('tcancel').hidden = true; $('tcancel').classList.remove('hot');
      clearTimeout(tipT); if (tipped) { tipped = false; $('tip').hidden = true; }
      SG.aimRange = 0;
      const ta = touchAim; touchAim = null; if (view) view.indicator = null;
      if (!ok || !ta || ta.cancel || !world) return;
      if (ta.info) { const sk = SG.skillAt(world.player, i); world.say(sk.passive ? `${sk.name} 是被動技能（長按看說明）` : world.player.pts > 0 ? `${sk.name} 還沒學：點技能上的 ＋` : `${sk.name} 還沒學`, 'warn'); return; }
      if (!ta.moved) { castSkill(i); return; } // 點一下：自動瞄準
      const me = world.player, A = SG.aimOf(SG.skillAt(me, i), me.skillLv[i]);
      if (A.kind === 'unit') {
        const t = unitTarget(i, ta.p);
        if (!t) { world.tell(me, `${SG.skillAt(me, i).name} 要指向一個目標`, 'warn'); return; }
        me.input.skill = { i, x: t.x, y: t.y, tid: t.id };
      } else me.input.skill = { i, x: ta.p[0], y: ta.p[1] };
    };
    b.addEventListener('pointerup', (e) => end(e, true));
    b.addEventListener('pointercancel', (e) => end(e, false));
  });
}
// 手機震動回饋（不支援就略過；設定可關）
// 暫停（單機才能暫停；連線對戰不能停）：Esc、觸控的「停／續」鍵、切到背景時自動暫停
function setPaused(on, why) {
  if (!world || world.net || world.over !== null || !$('brief').hidden) return; // 列傳的戰前簡報開著：按「出陣」才開始
  paused = on;
  $('tpause').textContent = on ? '續' : '停';
  world.say(on ? (why || '已暫停') + (touchMode ? '：點右上的「續」繼續' : '（Esc 繼續）') : '繼續', 'info');
}
document.addEventListener('visibilitychange', () => {
  if (document.hidden && world && !world.net && world.over === null && !paused) setPaused(true, '切到背景，遊戲已暫停');
});
// 手機：取消連點兩下放大。iOS 有時不理會 viewport 與 touch-action，兩次觸控間隔太短就擋掉第二下的預設動作
// （遊戲按鍵用 pointerdown，不受影響；只有選單按鈕極快連點時第二下不算）
{
  // 雙擊放大一定點在同一點：只有「0.3 秒內、30px 內」的第二下才擋（連點兩個不同按鈕不受影響）
  let last = { t: 0, x: 0, y: 0 };
  document.addEventListener('touchend', (e) => {
    const p = e.changedTouches && e.changedTouches[0], now = Date.now();
    if (!p) return;
    if (now - last.t < 300 && Math.hypot(p.clientX - last.x, p.clientY - last.y) < 30 && !(e.target instanceof Element && e.target.closest('input, textarea, select'))) e.preventDefault();
    last = { t: now, x: p.clientX, y: p.clientY };
  }, { passive: false });
  document.addEventListener('dblclick', (e) => e.preventDefault());
  document.addEventListener('gesturestart', (e) => { if (document.body.classList.contains('touch-ui')) e.preventDefault(); }); // 對戰中不要雙指縮放頁面
}
// iPhone／iPad 的 Safari：不支援全螢幕功能，網址列只能靠「加入主畫面」隱藏
const IOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
const STANDALONE = (window.matchMedia && matchMedia('(display-mode: fullscreen), (display-mode: standalone)').matches) || navigator.standalone === true;
// 手機：出戰（或連線開始配對）時進入全螢幕並鎖定橫向（只能在點擊的當下呼叫；iPhone 的 Safari 不支援，會安靜略過）
function fullscreen() {
  if (!(window.matchMedia && matchMedia('(pointer: coarse)').matches) || document.fullscreenElement) return;
  const el = document.documentElement;
  if (!el.requestFullscreen) return;
  el.requestFullscreen({ navigationUI: 'hide' }).then(() => { try { const o = screen.orientation; if (o && o.lock) o.lock('landscape').catch(() => {}); } catch (e) { /* 不支援鎖定方向 */ } }).catch(() => {});
}
function buzz(ms) { try { if (settings.haptics !== false && navigator.vibrate) navigator.vibrate(ms); } catch (e) { /* 忽略 */ } }

// ---------- HUD ----------
let hudT = 0, bannerT = 0, toastT = 0;
// 技能說明：滑鼠移到技能上顯示（數值標出目前等級）
// 裝備說明框：圖示、價格、屬性、效果、冷卻；在欄位上時附賣價
function itemTipHTML(it, owned) {
  const stats = SG.itemStatText(it), cd = SG.itemCd(it);
  return `<h4><img src="${SG.itemIconURL(it, 68)}" alt="">${it.name}<small>${it.cat}${it.cost ? ' · ' + it.cost + ' 金' : ''}${it.wood ? ' ＋ ' + it.wood + ' 木' : ''}</small></h4>
    ${stats ? `<p><b>${stats}</b></p>` : ''}${it.text ? `<p>${it.text}</p>` : ''}
    ${cd ? `<p class="k">冷卻 ${cd} 秒</p>` : ''}${it.from ? `<p class="k">由 ${it.from.map((f) => SG.ITEM[f].name).join('＋')} 合成：身上有的零件會折抵價格並併入成品</p>` : ''}${it.source ? `<p class="k">${it.source}</p>` : ''}
    ${owned && it.cost ? `<p class="k">商店開著時點一下賣出：${SG.sellPrice(it)} 金</p>` : ''}`;
}
function showItemTip(it, btn, owned) {
  const tip = $('tip');
  if (!it) { tip.hidden = true; return; }
  const r = btn.getBoundingClientRect();
  tip.innerHTML = itemTipHTML(it, owned);
  tip.style.left = Math.max(8, Math.min(innerWidth - 328, r.left + r.width / 2 - 160)) + 'px';
  tip.style.bottom = (innerHeight - r.top + 8) + 'px';
  tip.hidden = false;
}
// ---------- 查看（v0.3.8）：左鍵點單位看狀態與技能、Tab 戰況表 hover、陣亡畫面的擊殺者 ----------
let insp = null;
const FAC_NAME = { shu: '蜀', wu: '吳', wei: '魏' };
const KIND_NAME = { minion: '小兵', tower: '城寨', base: '本營', barracks: '兵營', granary: '糧倉', creep: '黃巾賊', boss: '神將', cart: '糧車', seal: '神器' };
const ST_NAME = [['stun', '暈眩'], ['freeze', '冰凍'], ['knockup', '擊飛'], ['down', '倒地'], ['silence', '沉默'], ['root', '定身'], ['fear', '恐懼'], ['taunt', '嘲諷'], ['charm', '魅惑'], ['confuse', '混亂'], ['disarm', '繳械'], ['slow', '緩速'], ['invis', '隱身']];
const heroSpec = (id) => SG.HEROES.find((h) => h.id === id);
// 頭像轉成圖片網址（HTML 裡用；同一個武將＋尺寸只畫一次）
const portraitURLs = new Map();
function portraitURL(spec, size) {
  const key = spec.id + '@' + size;
  let url = portraitURLs.get(key);
  if (!url) { const c = document.createElement('canvas'); portrait(c, spec, size); url = c.toDataURL(); portraitURLs.set(key, url); }
  return url;
}
// 技能說明：{a/b/c} 依等級標出目前數值（等級不知道就用 1 級）
function skillDescHTML(s, lv) {
  const show = Math.max(1, lv || 0);
  return s.desc.replace(/\{([^}]+)\}/g, (_, g) => { const a = g.split('/'); return `<b>${a[Math.min(a.length, show) - 1]}</b>`; });
}
const lvDots = (lv, max) => `<span class="ldots">${Array.from({ length: max }, (_, k) => `<em class="${k < lv ? 'on' : ''}"></em>`).join('')}</span>`;
// 武將說明（戰況表 hover、查看面板的技能 hover 共用）
function heroTipHTML(h, skillLv) {
  const sp = h.spec || h;
  return `<h4><img src="${portraitURL(sp, 48)}" alt="">${sp.name}<small>${FAC_NAME[sp.faction] || ''} · ${SG.classOf(sp) || ''}${sp.role ? ' · ' + sp.role : ''}${h.lv ? ' · Lv ' + h.lv : ''}</small></h4>`
    + sp.skills.map((s, i) => `<p><span class="k">${['Q', 'W', 'E', 'R'][i]}</span> <b>${s.name}</b>${s.passive ? ' <small>被動</small>' : ''}${skillLv ? ' ' + lvDots(skillLv[i] || 0, i === 3 ? 3 : 4) : ''}<br>${skillDescHTML(s, skillLv && skillLv[i])}</p>`).join('');
}
function skillTipHTML(s, i, lv) {
  return `<h4>${s.name}<small>${['Q', 'W', 'E', 'R'][i]}${lv != null ? `　Lv ${lv} / ${i === 3 ? 3 : 4}` : ''}${s.passive ? '　被動' : ''}</small></h4><p>${skillDescHTML(s, lv)}</p>`;
}
function placeTipNear(el) {
  const r = el.getBoundingClientRect(), tip = $('tip');
  tip.hidden = false;
  const th = tip.offsetHeight;
  tip.style.left = Math.max(8, Math.min(innerWidth - 328, r.right + 8 > innerWidth - 328 ? r.left - 328 : r.right + 8)) + 'px';
  tip.style.bottom = Math.max(8, Math.min(innerHeight - th - 8, innerHeight - r.bottom)) + 'px';
}
// 查看面板：看得到才顯示（死了、走進霧裡、離開視野就自動收起）
function inspVisible(u) {
  const w = world;
  return !!(u && w && u.alive && w.units.includes(u) && (u.team === w.player.team || !u.vis || u.vis[w.player.team]));
}
function renderInspect() {
  const box = $('insp');
  if (insp && !inspVisible(insp)) insp = null;
  if (!insp) { if (!box.hidden) { box.hidden = true; box.dataset.sig = ''; $('tip').hidden = true; } return; }
  const u = insp, me = world.player, hero = u.kind === 'hero' && u.spec && u.spec.skills;
  const ally = u.team === me.team, col = u.team === 2 ? '#e9c46a' : ally ? 'var(--ally)' : 'var(--foe)';
  // 頭（名字、頭像、技能）只在換單位或技能等級變了才重畫，滑鼠停在技能上的說明才不會一直閃
  const known = hero && (u === me || (u.skillLv && u.skillLv.some((v) => v > 0)));
  const sl = known ? u.skillLv : null;
  const sig = u.id + '|' + (sl ? sl.join('') : '') + '|' + (u.lv || '');
  if (box.dataset.sig !== sig) {
    box.dataset.sig = sig;
    box.hidden = false;
    box.innerHTML = `<button class="x-close" type="button" id="insp-x" aria-label="關閉">×</button>
      <div class="ih">${hero ? `<img src="${portraitURL(u.spec, 52)}" alt="">` : ''}<div><b style="color:${col}">${hero ? u.spec.name : u.name || KIND_NAME[u.kind] || ''}</b><small>${hero ? `Lv ${u.lv} · ${FAC_NAME[u.spec.faction] || ''} · ${SG.classOf(u.spec) || ''}` : (KIND_NAME[u.kind] || '') + (u.tier ? ` · ${u.tier} 級` : '')}${u.team === 2 ? ' · 中立' : ally ? ' · 友軍' : ' · 敵軍'}</small></div></div>
      <div class="ibar hp"><i></i><span></span></div>${hero && u.maxMp ? `<div class="ibar mp${SG.isNeng(u) ? ' neng' : ''}"><i></i><span></span></div>` : ''}
      <div class="ist" id="insp-st"></div><div class="ists" id="insp-sts"></div>
      ${hero ? `<div class="iitems" id="insp-it"></div><div class="isk">${u.spec.skills.map((s, i) => `<button type="button" data-s="${i}" style="--fx:${s._el && SG.EL ? SG.EL[s._el].col : u.spec.fx}"><b>${s.name[0]}</b><small>${s.name}</small>${sl ? lvDots(sl[i], i === 3 ? 3 : 4) : ''}</button>`).join('')}</div>` : ''}`;
  }
  const bar = (sel, v, text) => { const b = box.querySelector(sel); if (!b) return; b.style.setProperty('--v', Math.max(0, Math.min(1, v)).toFixed(3)); b.querySelector('span').textContent = text; };
  bar('.ibar.hp', u.hp / u.maxHp, `${Math.ceil(u.hp)} / ${Math.round(u.maxHp)}`);
  if (hero && u.maxMp) bar('.ibar.mp', u.mp / u.maxMp, `${Math.floor(u.mp)} / ${Math.round(u.maxMp)}`);
  // 數值：單機看得到全部；連線時別人的數值伺服器沒送，有才顯示
  const n = (v, d) => (typeof v === 'number' && (v || d) ? v : null);
  const parts = [['攻', n(u.atk) != null ? Math.round(u.atk) : null], ['法', hero && n(u.matk) != null ? Math.round(u.matk) : null], ['甲', n(u.armor, 1) != null ? (+u.armor).toFixed(1) : null], ['抗', hero && n(u.mr) != null ? (+u.mr).toFixed(1) : null],
    ['速', hero && n(u.asp) != null ? u.asp + '%' : null], ['移', n(u.ms) != null && world.speed ? Math.round(world.speed(u)) : null], ['程', n(u.range) != null ? Math.round(u.range) : null]].filter((p) => p[1] != null);
  const st = parts.map((p) => `<span>${p[0]} <b>${p[1]}</b></span>`).join('');
  if ($('insp-st').innerHTML !== st) $('insp-st').innerHTML = st;
  const S = u.st || {};
  const chips = ST_NAME.filter(([k]) => S[k] > 0 && (k !== 'slow' || (S.slowAmt || 0) > 0.05)).map(([, t]) => `<i class="bad">${t}</i>`)
    .concat(S.shield > 0 ? [`<i>護盾 ${Math.round(S.shield)}</i>`] : []).concat(u.defending ? ['<i>防禦中</i>'] : []).concat(S.msUp > 0 ? ['<i>加速</i>'] : []).concat(S.atkUp > 0 ? ['<i>攻擊提升</i>'] : [])
    .concat(u.seal && ally ? ['<i class="gold">持有玉璽</i>'] : []).concat(hero && world.lubu && world.lubu[u.team] > world.t ? [`<i class="gold">${SG.LUBU_BUFF.name}</i>`] : []).join('');
  if ($('insp-sts').innerHTML !== chips) $('insp-sts').innerHTML = chips;
  if (hero) {
    const ih = (u.items || []).map((it, i) => (it ? `<img src="${SG.itemIconURL(it, 44)}" alt="${it.name}" data-i="${i}">` : '<span></span>')).join('');
    if ($('insp-it').dataset.h !== ih) { $('insp-it').dataset.h = ih; $('insp-it').innerHTML = ih; }
  }
  const dock = $('dock').getBoundingClientRect();
  box.style.bottom = (touchMode ? 120 : Math.max(10, innerHeight - dock.top + 10)) + 'px';
}
// 陣亡畫面：誰殺了你（當下的等級、生命、裝備、技能）
function renderDead() {
  const me = world.player, box = $('dead');
  box.hidden = me.alive;
  if (me.alive) { box.dataset.sig = ''; return; }
  const k = me.deathBy, sig = Math.ceil(me.respawn) + '|' + (k ? k.name + k.hp + (k.it || []).join() : '');
  if (box.dataset.sig === sig) return;
  box.dataset.sig = sig;
  let who = '';
  if (k) {
    const sp = k.kind === 'hero' && heroSpec(k.sp);
    if (sp) {
      const items = (k.it || []).filter(Boolean).map((id) => SG.ITEM[id]).filter(Boolean);
      who = `<div class="kh"><img src="${portraitURL(sp, 64)}" alt=""><div><small>擊殺者</small><b>${sp.name}</b><span>Lv ${k.lv} · ${FAC_NAME[sp.faction] || ''} · ${SG.classOf(sp) || ''}</span></div></div>
        <div class="ibar hp" style="--v:${Math.max(0, Math.min(1, k.hp / k.mh)).toFixed(3)}"><i></i><span>剩 ${k.hp} / ${k.mh}</span></div>
        <div class="kit">${items.length ? items.map((it) => `<span><img src="${SG.itemIconURL(it, 44)}" alt="">${it.name}</span>`).join('') : '<em>沒有裝備</em>'}</div>
        <div class="ksk">${sp.skills.map((s, i) => { const lv = (k.sl || [])[i] || 0; return `<p><span class="kk">${['Q', 'W', 'E', 'R'][i]}</span> <b>${s.name}</b>${s.passive ? ' <small>被動</small>' : s.tg ? ' <small>開關</small>' : ''} ${lvDots(lv, i === 3 ? 3 : 4)}${lv ? '' : ' <small>未學</small>'}<br>${skillDescHTML(s, lv)}</p>`; }).join('')}</div>`; // 完整技能說明，數值標出擊殺者當下的等級
    } else who = `<div class="kh"><div><small>擊殺者</small><b>${k.name || KIND_NAME[k.kind] || '敵軍'}</b></div></div>`;
    if (k.help && k.help.length) who += `<p class="khelp">助攻：${k.help.join('、')}</p>`;
  }
  box.innerHTML = `<div class="dbox"><h3>陣亡　${Math.ceil(me.respawn)} 秒後復活</h3>${who}</div>`;
}
// 戰況表 hover：武將頭像／名字看武將說明，裝備圖示看裝備說明
function boardTip(e) {
  if (touchMode) return;
  const t = e.target instanceof Element ? e.target : null;
  const it = t && t.closest('[data-it]'), hc = t && t.closest('[data-hid]');
  if (it) { $('tip').innerHTML = itemTipHTML(SG.ITEM[it.dataset.it], false); placeTipNear(it); return; }
  if (hc) {
    const h = world.heroes().find((x) => x.id === +hc.dataset.hid); if (!h) return;
    const sl = h === world.player || (h.skillLv && h.skillLv.some((v) => v > 0)) ? h.skillLv : null;
    $('tip').innerHTML = heroTipHTML(h, sl); placeTipNear(hc); return;
  }
  $('tip').hidden = true;
}
// 觸控：說明框放在按鈕左上方（觸控版面沒有底部技能列可以對齊）
function placeTouchTip(btn) {
  const r = btn.getBoundingClientRect(), tip = $('tip');
  tip.style.left = Math.max(8, Math.min(innerWidth - 328, r.left - 330)) + 'px';
  tip.style.bottom = Math.max(8, innerHeight - r.top + 8) + 'px';
}
function showMlTip(btn) {
  const me = world.player, m = me.ml && SG.ML[me.ml], tip = $('tip');
  const r = btn.getBoundingClientRect(), dock = $('dock').getBoundingClientRect();
  tip.style.left = Math.max(8, Math.min(innerWidth - 328, r.left + r.width / 2 - 160)) + 'px'; tip.style.bottom = (innerHeight - dock.top + 8) + 'px'; tip.hidden = false;
  tip.innerHTML = m ? `<h4><img src="${SG.mlIconURL(m.id, 48)}" alt="" width="22" height="22" style="vertical-align:-5px;margin-right:6px">謀略・${m.name} <small>冷卻 ${m.cd} 秒</small></h4><p>${m.desc}</p><p class="k">按 F 施放</p>` : `<h4>謀略</h4><p>註冊會員即送「療傷」；其他謀略在商域用銅錢購買，開戰前在選將畫面挑一個帶進場。</p>`;
}
function showTip(i, btn) {
  const me = world.player, tip = $('tip');
  const r = btn.getBoundingClientRect(), dock = $('dock').getBoundingClientRect();
  tip.style.left = Math.max(8, Math.min(innerWidth - 328, r.left + r.width / 2 - 160)) + 'px';
  tip.style.bottom = (innerHeight - dock.top + 8) + 'px';
  tip.hidden = false;
  if (i === 4) {
    tip.innerHTML = `<h4>屬性加強 <small>${me.attr || 0} / 10</small></h4><p>每點全屬性 +2（武：生命、武將普攻、吃武力的技能；敏：攻速、護甲、敏將普攻、吃敏捷的技能；智：氣、智將普攻、吃智力的技能）。技能都學滿或還不能學時把點數放這裡。</p><p class="k">點按鈕、按 O 或 Alt＋O 投入一點${me.pts > 0 ? `　·　剩 ${me.pts} 點` : ''}</p>`;
    return;
  }
  const s = SG.skillAt(me, i), lv = me.skillLv[i], max = i === 3 ? 3 : 4, show = Math.max(1, lv);
  const desc = s.desc.replace(/\{([^}]+)\}/g, (_, g) => { const a = g.split('/'); return `<b>${a[Math.min(a.length, show) - 1]}</b><small>(${g})</small>`; });
  const cd = s.passive ? '' : s.tg ? `開關技：開啟時每發普攻耗 ${SG.L(s.tg.mp, show)} ${SG.resName(me)}　目前：${me.tgOn && me.tgOn[i] ? '開啟' : '關閉'}` : `冷卻 ${world.skillCd(me, s, i, show).toFixed(0)} 秒　${s.hpCost ? `耗血：目前生命 ${SG.L(s.hpCost, show)}%` : `耗${SG.resName(me)} ${world.skillCost(i, show, s)}`}`;
  const ak = SG.aimOf(s, show).kind;
  const kind = s.passive ? '被動' : s.tg ? '開關（按一下開／關）' : `${SG.SKILL_TYPE_NAME[ak] || ''}・${SG.ARCH_NAMES[s.arch] || ''}`;
  const typeLine = s.passive || s.tg ? '' : ak === 'unit' ? '<p class="k">點擊技：點選目標必中，不會被路上的單位擋住；在射程外會先走過去</p>' : ak === 'dir' ? `<p class="k">指向技：朝方向放，可能打偏或被擋；傷害、控制 +${Math.round((SG.SKILLSHOT_BONUS - 1) * 100)}%</p>` : '';
  const why = world.canLearn(me, i);
  const el = SG.EL && s._el && SG.EL[s._el];
  const elLine = el ? `<p class="k"><span class="el" style="--ec:${el.col}">${el.name}</span> 可觸發：${(EL_REACT[s._el] || []).map((r) => SG.REACT[r].name).join('、')}</p>` : '';
  // v0.3.0：技能成長類別與目前加成
  const cls = SG.skillScale(me.spec, i), attrV = SG.scaleAttr(me, cls);
  const grow = cls === 'fixed' ? (s.passive ? '' : `<p class="k">成長：固定（不吃屬性）</p>`) : SG.selfScaled(s) ? `<p class="k">成長：${SG.SCALE_NAME[cls]}（${cls === 'int' ? '法術' : '物理'}，傷害直接以${SG.ATTR_NAME[cls]}計算）</p>` : `<p class="k">成長：${SG.SCALE_NAME[cls]}（${cls === 'int' ? '法術' : '物理'}）＋${SG.SCALE_COEF[i]}×${cls === 'int' ? '法攻' : SG.ATTR_NAME[cls]}　目前 ＋${Math.round(SG.SCALE_COEF[i] * attrV)}</p>`;
  tip.innerHTML = `<h4>${s.name}${elTag(s)} <small>Lv ${lv} / ${max}　${kind}</small></h4><p>${desc}</p>${typeLine}${grow}${elLine}${cd ? `<p class="k">${cd}</p>` : ''}<p class="k">${lv === 0 ? '尚未學會　' : ''}${why ? (why === '沒有技能點' ? '' : why) : '可以升級：點「＋」或 Alt＋' + SCHEMES[settings.scheme].labels[i]}</p>`;
}
// 天賦被動（不佔技能格）的說明
function showTalTip(btn) {
  const me = world.player, p = me.spec.passive, tip = $('tip');
  if (!p) return;
  const r = btn.getBoundingClientRect(), dock = $('dock').getBoundingClientRect();
  tip.style.left = Math.max(8, Math.min(innerWidth - 328, r.left + r.width / 2 - 160)) + 'px';
  tip.style.bottom = (innerHeight - dock.top + 8) + 'px';
  const desc = SG.talDesc(me.spec, me.lv, (v, g) => g.includes('/') ? `<b>${v}</b><small>(${g})</small>` : v);
  const stack = p.stack ? `<p class="k">目前累積：${p.stack} +${me.talN || 0}${p.max ? `（上限 +${p.max}）` : ''}</p>` : '';
  tip.innerHTML = `<h4>${p.name} <small>天賦被動</small></h4><p>${desc}</p>${stack}${p.lv && p.lv.length > 1 ? `<p class="k">${p.lv.slice(1).join('、')} 級提升</p>` : ''}<p class="k">一開始就有，不用學、不佔技能格</p>`;
  tip.hidden = false;
}
let dockSpec = null; // 技能列是照哪一份武將設定建的（形態切換時要重建）
function buildDock() {
  const me = world.player, h = me.spec;
  dockSpec = h;
  portrait($('portrait'), h, 64);
  $('me-name').textContent = h.name;
  $('skills').innerHTML = (h.passive ? `<button type="button" class="sk tal" data-tal="1" style="--fx:${h.fx}"><kbd>天賦</kbd><b>${h.passive.name[0]}</b><span class="cdn"></span></button>` : '')
    + h.skills.map((s, i) => `<button type="button" class="sk${s.passive ? ' pas' : ''}" data-i="${i}" style="--fx:${s._el && SG.EL ? SG.EL[s._el].col : h.fx}">${s._el && SG.EL ? `<i class="ele">${SG.EL[s._el].name}</i>` : ''}
    <kbd>${SCHEMES[settings.scheme].labels[i]}</kbd><small></small><b>${s.name[0]}</b><span class="cdn"></span><span class="lv">${Array.from({ length: i === 3 ? 3 : 4 }, () => '<em></em>').join('')}</span><i class="up" title="升級">＋</i></button>`).join('')
    + `<button type="button" class="sk attr" data-i="4"><kbd>O</kbd><b>屬</b><span class="cdn"></span><span class="lv"><em></em></span><i class="up" title="升級">＋</i></button>`
    + `<button type="button" class="sk mlk${me.ml ? '' : ' off'}" data-mlk="1"><kbd>F</kbd><b>${me.ml ? `<img src="${SG.mlIconURL(me.ml, 72)}" alt="${SG.ML[me.ml].name}">` : '謀'}</b><span class="cdn"></span></button>`;
  $('skills').onclick = (e) => {
    const b = e.target.closest('.sk'); if (!b) return;
    if (b.dataset.tal) { showTalTip(b); return; }
    if (b.dataset.mlk) { castMl(); return; }
    const i = +b.dataset.i;
    if (i === 4 || e.target.closest('.up') || e.altKey || e.ctrlKey) { world.player.input.learn = i; return; }
    castSkill(i);
  };
  $('skills').onmouseover = (e) => { const b = e.target.closest('.sk'); if (!b) return; if (b.dataset.tal) showTalTip(b); else if (b.dataset.mlk) showMlTip(b); else showTip(+b.dataset.i, b); };
  $('skills').onmouseleave = () => { $('tip').hidden = true; };
  $('tskills').innerHTML = h.skills.map((s, i) => `<button type="button" class="tsk${s.passive ? ' pas' : ''}" data-s="${i}" style="--fx:${s._el && SG.EL ? SG.EL[s._el].col : h.fx}" aria-label="${s.name}">${s.name[0]}<span class="cdn"></span><i class="up" aria-label="升級">＋</i></button>`).join('');
  bindTouchSkills();
  $('items').innerHTML = Array.from({ length: 6 }, (_, i) => `<button type="button" class="it" data-i="${i}" data-id="x"></button>`).join('');
  $('items').onmouseover = (e) => { if (touchMode) return; const b = e.target.closest('.it'); if (b) showItemTip(world.player.items[+b.dataset.i], b, true); };
  $('items').onmouseleave = () => { $('tip').hidden = true; };
  $('items').onclick = (e) => {
    if (longPressed()) return; // 長按看說明之後放開：不要順便使用
    const b = e.target.closest('.it'); if (!b) return;
    const i = +b.dataset.i;
    if (!$('shop').hidden && world.inShop(world.player)) { const it = world.player.items[i]; if (world.sell(world.player, i)) note(`賣出 ${it.name}，拿回 ${SG.sellPrice(it)} 金`); renderShop(); }
    else world.player.input.item = i;
  };
  $('btn-shop').onclick = toggleShop;
  $('shop-x').onclick = toggleShop;
  $('shop').hidden = true; $('board').hidden = true;
  shopCat = '兵器'; buildShopTabs();
}
// 新手引導：每個提示在存檔裡只出現一次，在對的時機出現
function coach(w, me) {
  if (toastT > 0 || Meta.profile.games > 5) return;
  const say = (id, text) => { if (Meta.tip(id)) { $('toast').textContent = text; $('toast').className = 'toast good'; $('toast').style.opacity = 1; toastT = 4.5; return true; } return false; };
  if (me.manual && me.pts > 0 && w.t > 2 && say('learn', touchMode ? '有技能點：點技能鍵右上的 ＋ 學技能' : `有技能點：按 Alt＋${SCHEMES[settings.scheme].labels.join('/')}，或點技能上的 ＋ 學技能`)) return;
  if (me.alive && me.gold >= 500 && Math.hypot(me.x - SG.MAP.bases[me.team].x, me.y - SG.MAP.bases[me.team].y) < SG.MAP.shopR && say('shop', touchMode ? '你在本營裡：點右上的「店」買裝備' : '你在本營裡：按 P 開商店買裝備')) return;
  if (!me.alive && say('dead', touchMode ? '陣亡了：復活前可以點「店」買裝備，好好準備再上' : '陣亡了：復活前可以按 P 買裝備，好好準備再上')) return;
  if (w.seal.state === 'ground' && say('seal', '傳國玉璽出現在下游沙洲：武將普攻五下奪璽（敵方打一下就重來），持有者每秒回血回氣')) return;
}
function hud(dt) {
  const w = world, me = w.player;
  if (me.spec !== dockSpec) buildDock(); // 切換形態（v0.5.0）：技能列換成新形態的
  hudT -= dt; bannerT -= dt; toastT -= dt;
  // 手機震動：被重擊、擊殺武將、陣亡
  if (touchMode) {
    const hk = hud.hk || (hud.hk = { hp: me.hp, kills: me.kills, alive: me.alive, t: 0 });
    hk.t -= dt;
    if (me.kills > hk.kills) buzz([30, 40, 30]);
    else if (hk.alive && !me.alive) buzz(120);
    else if (me.alive && hk.hp - me.hp > me.maxHp * 0.08 && hk.t <= 0) { buzz(14); hk.t = 0.35; }
    hk.hp = me.hp; hk.kills = me.kills; hk.alive = me.alive;
  }
  // 訊息
  while (msgIdx < w.msgs.length) {
    const m = w.msgs[msgIdx++];
    if (m.to && m.to !== me.id) continue;
    if (m.kind === 'line') { story.lines.push(m); continue; }
    if (m.kind === 'card') { $('ccard').innerHTML = `<div>${esc(m.text)}</div>${m.src ? `<cite>${esc(m.src)}</cite>` : ''}`; $('ccard').classList.add('on'); story.cardT = 4.2; story.lineT = Math.max(story.lineT, 4.2); continue; }
    if (m.kind === 'big' || m.kind === 'kill') {
      $('banner').textContent = m.text; $('banner').style.opacity = 1; bannerT = 3;
      $('banner').style.color = m.kind === 'kill' ? (m.team === me.team ? '#ffd46b' : '#d6b8ff') : '';
      if (SG.Audio) SG.Audio.play(m.kind === 'kill' ? 'drum' : 'gong', null, null, null, 0.7);
    }
    else if (m.kind === 'good' && /升到/.test(m.text)) { $('toast').textContent = m.text; $('toast').className = 'toast good'; $('toast').style.opacity = 1; toastT = 1.6; if (SG.Audio) SG.Audio.play('levelup'); }
    else { $('toast').textContent = m.text; $('toast').className = 'toast ' + m.kind; $('toast').style.opacity = 1; toastT = 1.6; }
  }
  if (msgIdx > w.msgs.length) msgIdx = w.msgs.length;
  if (!w.net) coach(w, me);
  // 背景音樂跟著戰況：附近看得到的敵將越多、正在交戰，就越激昂
  if (SG.Audio && SG.Audio.setIntensity && me.alive) {
    const n = w.campaign
      ? w.units.filter((u) => u.alive && u.team === 1 - me.team && u.vis && u.vis[me.team] && SG.gd(u.x, u.y, me.x, me.y) < 900).length * 0.4 // 列傳：敵兵也算
      : w.heroes(1 - me.team).filter((h) => h.alive && h.vis && h.vis[me.team] && SG.gd(h.x, h.y, me.x, me.y) < 1000).length;
    SG.Audio.setIntensity((me.combatT && w.t - me.combatT < 3 ? 0.5 : 0) + n * 0.15);
  }
  if (bannerT <= 0) $('banner').style.opacity = 0;
  if (toastT <= 0) $('toast').style.opacity = 0;
  if (hudT > 0) return;
  hudT = 0.1;
  view.cardY = $('help').hidden ? 170 : $('help').getBoundingClientRect().bottom + 10;
  $('k0').textContent = w.kills[0]; $('k1').textContent = w.kills[1]; $('clock').textContent = fmt(w.t);
  $('k0').hidden = $('k1').hidden = !!w.campaign; // 列傳沒有兩軍擊殺數
  storyHud(w);
  const sl = w.seal;
  $('wind').textContent = w.wind.on > 0 ? `東風 ${Math.ceil(w.wind.on)}秒` : `東風 ${fmt(w.wind.next)} 後`;
  $('wind').className = w.wind.on > 0 ? 'st on' : 'st';
  $('seal').textContent = sl.state === 'wait' ? `玉璽 ${fmt(sl.t)} 後` : sl.state === 'ground' ? '玉璽在地上' : `玉璽：${sl.holder ? sl.holder.name : '敵方持有'}`;
  $('seal').className = 'st' + (sl.state === 'held' ? (sl.holder.team === me.team ? ' ally' : ' foe') : sl.state === 'hidden' ? ' foe' : sl.state === 'ground' ? ' on' : '');
  $('wind').hidden = $('seal').hidden = !!w.campaign; // 列傳沒有東風、玉璽
  $('supply').hidden = !(w.supply[me.team] > 0);
  $('supply').textContent = `糧草充足 ×${w.supply[me.team]}`;
  // 飛將之威（擊敗呂布的全隊增益）：自己隊或敵隊有就顯示剩餘時間
  const lb = w.lubu, lbT = lb ? (lb[me.team] > w.t ? me.team : lb[1 - me.team] > w.t ? 1 - me.team : -1) : -1;
  $('lubu').hidden = lbT < 0;
  if (lbT >= 0) { $('lubu').textContent = `${lbT === me.team ? '' : '敵軍 '}${SG.LUBU_BUFF.name} ${fmt(lb[lbT] - w.t)}`; $('lubu').className = 'st ' + (lbT === me.team ? 'ally' : 'foe'); $('lubu').title = '擊敗呂布：全隊攻擊 +15%、攻速 +15%、移速 +8%、受到傷害 -10%'; }
  $('feed').innerHTML = w.feed.filter((f) => w.t - f.t < 8).slice(-5).map((f) => `<div style="--c:${f.team === me.team ? 'var(--ally)' : 'var(--foe)'}">${f.text}</div>`).join('');
  const setBar = (id, v, text) => { const b = $(id); b.style.setProperty('--v', Math.max(0, Math.min(1, v)).toFixed(3)); const s = b.querySelector('span'); if (s) s.textContent = text; };
  setBar('hpbar', me.hp / me.maxHp, `${Math.ceil(me.hp)} / ${me.maxHp}`);
  setBar('mpbar', me.mp / me.maxMp, `${Math.floor(me.mp)} / ${me.maxMp}`);
  $('mpbar').classList.toggle('neng', SG.isNeng(me));
  $('mpbar').hidden = SG.noRes(me);
  const lo = SG.expToLevel(me.lv), hi = SG.expToLevel(me.lv + 1);
  setBar('xpbar', me.lv >= SG.MAX_LV ? 1 : (me.exp - lo) / (hi - lo));
  $('me-lv').textContent = 'Lv ' + me.lv + (me.pts > 0 ? `　＋${me.pts}` : '');
  $('me-lv').classList.toggle('pts', me.pts > 0);
  const tb = $('skills').querySelector('.tal');
  if (tb && me.spec.passive && me.spec.passive.stack) { const n = me.talN || 0; tb.querySelector('.cdn').textContent = n ? String(n) : ''; tb.classList.toggle('full', !!me.spec.passive.max && n >= me.spec.passive.max); } // 會累積的天賦：按鈕上顯示層數
  const ab = $('skills').querySelector('.attr');
  if (ab) { ab.classList.toggle('can', !world.canLearn(me, 4)); ab.querySelector('.cdn').textContent = me.attr ? me.attr : ''; }
  const mb = $('skills').querySelector('.mlk');
  if (mb && me.ml) { const m = SG.ML[me.ml]; mb.style.setProperty('--cd', me.mlCd > 0 ? (me.mlCd / m.cd).toFixed(3) : 0); mb.querySelector('.cdn').textContent = me.tp ? '引' : me.mlCd > 0 ? Math.ceil(me.mlCd) : ''; }
  if (touchMode && $('tml')) { const m = me.ml && SG.ML[me.ml]; $('tml').hidden = !m; if (m) { $('tml').style.setProperty('--cd', me.mlCd > 0 ? (me.mlCd / m.cd).toFixed(3) : 0); $('tml').querySelector('.cdn').textContent = me.tp ? '引' : me.mlCd > 0 ? Math.ceil(me.mlCd) : ''; if ($('tml').dataset.ml !== m.id) { $('tml').dataset.ml = m.id; $('tml').querySelector('b').innerHTML = `<img src="${SG.mlIconURL(m.id, 96)}" alt="${m.name}">`; } } }
  $('skills').querySelectorAll('.sk:not(.attr):not(.mlk):not(.tal)').forEach((b, i) => {
    const s = SG.skillAt(me, i), lv = me.skillLv[i];
    b.classList.toggle('can', !world.canLearn(me, i));
    const full = s.passive ? 0 : w.skillCd(me, s, i, Math.max(1, lv));
    b.style.setProperty('--cd', s.passive || !lv ? 0 : Math.max(0, me.cd[i] / full).toFixed(3));
    b.classList.toggle('off', !lv || (!s.passive && me.mp < w.skillCost(i, lv, s)));
    b.querySelector('.cdn').textContent = me.cd[i] > 0 && !s.passive ? Math.ceil(me.cd[i]) : '';
    const sn = s.stack && lv ? me[s.stack] || 0 : -1; // 會累積的層數（被動，或黃蓋「傷痕」這種主動招）：按鈕右上角顯示，滿了變金色
    b.classList.toggle('stk', sn >= 0); b.classList.toggle('full', sn >= 0 && !!s.max && sn >= s.max);
    if (sn >= 0) b.querySelector('.cdn').textContent = sn > 0 ? String(sn) : ''; // 只顯示層數（黃蓋「傷痕」的 0.5 秒冷卻不顯示，免得被看成 1 道）
    b.classList.toggle('rdy', !!(s.passive && lv && (me.rdy ? me.rdy[i] : s.ready && s.ready(me, w)))); // 蓄好了的被動：按鈕發光（線上由伺服器算好送 me.rdy）
    b.querySelector('small').textContent = s.passive || !lv ? '' : s.tg ? SG.L(s.tg.mp, lv) + '/發' : s.hpCost ? SG.L(s.hpCost, lv) + '%' : w.skillCost(i, lv, s) || ''; // 不耗資源的招不顯示 0
    b.querySelector('small').classList.toggle('hp', !!s.hpCost); // 耗血招：紅字顯示目前生命的 %
    const rc = me.rc && me.rc[i];
    b.classList.toggle('tgon', !!(s.tg && me.tgOn && me.tgOn[i]) || !!rc);
    if (rc) b.querySelector('.cdn').textContent = rc.alt ? '' : '再';
    const gl = b.querySelector('b'); if (gl.textContent !== s.name[0]) gl.textContent = s.name[0]; // 兩段式：第二段開著時換成第二段的字
    b.querySelectorAll('.lv em').forEach((e, k) => e.classList.toggle('on', k < lv));
  });
  if (touchMode) {
    $('tskills').querySelectorAll('.tsk').forEach((b, i) => {
      const s = SG.skillAt(me, i), lv = me.skillLv[i], full = s.passive ? 0 : w.skillCd(me, s, i, Math.max(1, lv));
      b.classList.toggle('can', !world.canLearn(me, i));
      b.style.setProperty('--cd', s.passive || !lv ? 0 : Math.max(0, me.cd[i] / full).toFixed(3));
      b.classList.toggle('off', !lv || (!s.passive && me.mp < w.skillCost(i, lv, s)));
      b.querySelector('.cdn').textContent = me.rc && me.rc[i] && !me.rc[i].alt ? '再' : me.cd[i] > 0 && !s.passive ? Math.ceil(me.cd[i]) : '';
      const sn = s.stack && lv ? me[s.stack] || 0 : -1;
      b.classList.toggle('stk', sn >= 0); b.classList.toggle('full', sn >= 0 && !!s.max && sn >= s.max);
      if (sn >= 0) b.querySelector('.cdn').textContent = sn > 0 ? String(sn) : '';
      b.classList.toggle('rdy', !!(s.passive && lv && (me.rdy ? me.rdy[i] : s.ready && s.ready(me, w))));
      if (b.firstChild && b.firstChild.nodeType === 3 && b.firstChild.textContent !== s.name[0]) b.firstChild.textContent = s.name[0];
    });
    $('tattr').classList.toggle('can', !world.canLearn(me, 4));
  }
  $('items').querySelectorAll('.it').forEach((b, i) => {
    const it = me.items[i], id = it ? it.id : '';
    if (b.dataset.id !== id) { b.dataset.id = id; b.innerHTML = (it ? `<img src="${SG.itemIconURL(it, 60)}" alt="${it.name}">` : '') + `<kbd>${i + 1}</kbd><span class="cdn"></span><span class="qty"></span>`; }
    const q = SG.itemQty(me, i); b.querySelector('.qty').textContent = q > 1 ? q : ''; // 疊加的消耗品：右下角顯示數量
    const cdMax = it ? SG.itemCd(it) : 0, cd = me.icd[i] || 0;
    b.style.setProperty('--cd', cdMax && cd > 0 ? (cd / cdMax).toFixed(3) : 0);
    b.querySelector('.cdn').textContent = cd > 0 ? Math.ceil(cd) : '';
  });
  $('gold').textContent = Math.floor(me.gold) + ' 金 · ' + (me.wood || 0) + ' 木';
  const atk = Math.round(me.atk * (me.st.atkUp > 0 ? 1 + me.st.atkUpAmt : 1));
  // v0.3.0：物攻／法攻、物防／法防、穿透（有才顯示）；滑鼠移上去看三圍
  const pen = (me.apen ? `<span>物穿 <b>${me.apen}</b></span>` : '') + (me.mpen ? `<span>法穿 <b>${me.mpen}</b></span>` : '');
  $('stats').innerHTML = `<span>攻 <b>${atk}</b></span><span>法 <b>${Math.round(me.matk || 0)}</b></span><span>甲 <b>${me.armor.toFixed(1)}</b></span><span>抗 <b>${(me.mr || 0).toFixed(1)}</b></span><span>速 <b>${w.net ? me.asp : Math.round(SG.effAsp(me))}%</b></span><span>移 <b>${Math.round(w.speed(me))}</b></span>${pen}`;
  $('stats').title = `武 ${Math.round(me.str || 0)}　敏 ${Math.round(me.agi || 0)}　智 ${Math.round(me.int || 0)}（${SG.CLASS_NAME[me.spec.attr || (SG.ROLES[me.spec.statRole || me.spec.role] || {}).main] || ''}）`;
  renderDead();
  renderInspect();
  if (!$('shop').hidden) renderShop(true);
  if (!$('board').hidden) renderBoard();
}

// ---------- 商店 ----------
let shopCat = '兵器';
function buildShopTabs() {
  $('shop-tabs').innerHTML = SG.ITEM_CATS.filter((c) => c !== '神器').map((c) => `<button class="btn" type="button" data-c="${c}" aria-pressed="${c === shopCat}">${c}</button>`).join('');
  $('shop-tabs').onclick = (e) => { const b = e.target.closest('button'); if (!b) return; shopCat = b.dataset.c; buildShopTabs(); renderShop(); };
}
let shopSig = '';
// 裝備層級（v0.3.6）：基本 → 中裝 → 大裝 → 神兵／奇書
const LV_NAME = { 1: '基本', 2: '中裝', 3: '大裝', 4: '神兵奇書' };
function renderShop(soft) {
  const me = world.player;
  const list = SG.ITEMS.filter((it) => it.cat === shopCat);
  const sig = shopCat + '|' + list.map((it) => world.canBuy(me, it) + world.priceOf(me, it)).join(',') + '|' + Math.floor(me.gold / 50) + '|' + (me.wood || 0);
  $('shop-where').textContent = world.inShop(me) ? `可購買 · ${Math.floor(me.gold)} 金 · ${me.wood || 0} 木` : SG.MAP.shopHint || '回本營、神秘商店或長江商船才能購買';
  // 你的裝備：點一下賣出（8 折）；不在商店範圍內就只能看
  const ownSig = me.items.map((it, i) => (it ? it.id + 'x' + SG.itemQty(me, i) : '-')).join(',') + (world.inShop(me) ? 1 : 0);
  if ($('shop-own').dataset.sig !== ownSig) {
    $('shop-own').dataset.sig = ownSig;
    $('shop-own').innerHTML = me.items.map((it, i) => it ? `<button type="button" data-sell="${i}"${world.inShop(me) && it.cost ? '' : ' disabled'} title="${it.name}"><img src="${SG.itemIconURL(it, 72)}" alt="">${SG.itemQty(me, i) > 1 ? `<span class="qty">${SG.itemQty(me, i)}</span>` : ''}${it.cost ? `<span class="sell">賣 ${SG.sellPrice(it)}</span>` : '<span>不能賣</span>'}</button>` : '<button type="button" disabled><span style="height:36px"></span><span>空</span></button>').join('');
  }
  if (soft && sig === shopSig) return;
  shopSig = sig;
  renderShopTree();
  // 推薦出裝：下一件推薦成品，一鍵買（錢不夠先買缺的零件）
  const rec = SG.nextRecBuy(world, me), nx = rec.next && SG.ITEM[rec.next], by = rec.buy && SG.ITEM[rec.buy];
  $('shop-rec').innerHTML = nx ? `<img src="${SG.itemIconURL(nx, 80)}" alt=""><b>推薦：${nx.name}</b><button class="btn primary" type="button" id="shop-rec-buy"${by && world.inShop(me) ? '' : ' disabled'}>${by ? (by === nx ? `買下 ${world.priceOf(me, nx)} 金` : `先買 ${by.name} ${world.priceOf(me, by)} 金`) : '錢不夠'}</button><small>${SG.itemStatText(nx) || nx.text || ''}</small>` : '';
  if ($('shop-rec-buy')) $('shop-rec-buy').onclick = () => { const r = SG.nextRecBuy(world, me); if (r.buy && world.buy(me, r.buy)) { note(`買下 ${SG.ITEM[r.buy].name}`); if (SG.Audio) SG.Audio.play('coin'); buzz(12); } shopSig = ''; renderShop(); };
  $('shop-grid').innerHTML = list.map((it) => {
    const why = world.canBuy(me, it), price = world.priceOf(me, it);
    const cost = price < it.cost ? `合成 ${price} 金 <s>${it.cost}</s>` : `${it.cost} 金`;
    return `<button type="button" class="item${price < it.cost ? ' combine' : ''}${it.id === shopTree ? ' sel' : ''}" data-id="${it.id}"${why ? ' aria-disabled="true"' : ''} title="${why || ''}"><img src="${SG.itemIconURL(it, 80)}" alt="">${it.lv ? `<i class="lvb lv${it.lv}">${it.lv === 4 && it.cat === '甲冑' ? '奇裝' : LV_NAME[it.lv] || ''}</i>` : ''}<b>${it.name}</b><span>${cost}${it.wood ? ' ＋ ' + it.wood + ' 木' : ''}</span><small>${SG.itemStatText(it) || it.text}</small></button>`;
  }).join('');
}
$('shop-grid').addEventListener('click', (e) => {
  if (longPressed()) return; // 長按看說明之後放開：不要順便購買
  const b = e.target.closest('.item'); if (!b) return; // 買不起的也能點來看合成樹（aria-disabled，不用 disabled）
  const it = SG.ITEM[b.dataset.id];
  // v0.3.8：點第一下鎖定並顯示合成樹（捲過去、避開固定的標題列），再點一下同一件才購買
  if (shopTree !== it.id) { shopTree = it.id; shopSig = ''; renderShop(); $('shop').scrollTop = Math.max(0, $('shop-tree').offsetTop - 60); return; }
  const why = world.canBuy(world.player, it);
  if (why) { note(`${it.name}：${why}`); return; }
  buyItem(it);
});
function buyItem(it) {
  if (world.buy(world.player, it.id)) { note(`買下 ${it.name}${it.text ? '：' + it.text : ''}`); if (SG.Audio) SG.Audio.play('coin'); }
  shopSig = ''; renderShop();
}
// 合成樹（v0.3.8）：點大裝（第 3、4 層）顯示它由哪些零件合成；身上已有的零件標「已有」（會折抵價格），點任一格就買那一件
let shopTree = null;
function renderShopTree() {
  const box = $('shop-tree'), root = shopTree && SG.ITEM[shopTree];
  if (!root) { box.hidden = true; box.innerHTML = ''; return; }
  const me = world.player, pool = me.items.filter(Boolean).map((i) => i.id);
  const node = (id, top) => {
    const it = SG.ITEM[id];
    const k = top ? -1 : pool.indexOf(id), own = k >= 0;
    if (own) pool.splice(k, 1); // 已有的零件不用再往下展開
    const why = own ? '已有' : world.canBuy(me, it), price = world.priceOf(me, it);
    const kids = !own && it.from ? `<ul>${it.from.map((f) => node(f, false)).join('')}</ul>` : '';
    return `<li><button type="button" class="node${own ? ' own' : ''}" data-buy="${it.id}"${why ? ` disabled title="${why}"` : ''}><img src="${SG.itemIconURL(it, 52)}" alt="">${it.name}<small>${own ? '✓ 已有' : price < it.cost ? `${price} 金` : `${it.cost} 金`}</small></button>${kids}</li>`;
  };
  const tree = node(root.id, true), why = world.canBuy(me, root), price = world.priceOf(me, root);
  box.hidden = false;
  box.innerHTML = `<div class="tt"><img src="${SG.itemIconURL(root, 64)}" alt="" width="32" height="32"><b>${root.name}${root.from ? '　合成樹' : ''}</b><button class="btn primary" type="button" data-buy="${root.id}"${why ? ` disabled title="${why}"` : ''}>${why && why !== '金錢不足' ? why : `買下 ${price} 金`}</button><button class="x-close" type="button" data-tree-x aria-label="收起合成樹" style="width:28px;height:28px;font-size:18px">×</button></div>${root.from ? `<ul>${tree}</ul>` : ''}<p class="note" style="margin:0">${root.from ? '點樹上任一件購買；綠框是身上已有的零件，會折抵價格並併入成品。' : `基本裝備，可以合成：${SG.ITEMS.filter((x) => x.from && x.from.includes(root.id)).map((x) => x.name).join('、') || '（不是任何裝備的材料）'}。`}再點一下清單上的這件也能直接購買。</p>`;
}
$('shop-tree').addEventListener('click', (e) => {
  const t = e.target instanceof Element ? e.target : null; if (!t) return;
  if (t.closest('[data-tree-x]')) { shopTree = null; renderShopTree(); return; }
  const b = t.closest('[data-buy]'); if (!b || b.disabled) return;
  buyItem(SG.ITEM[b.dataset.buy]);
});
$('shop-tree').addEventListener('mouseover', (e) => {
  if (touchMode) return;
  const b = e.target instanceof Element && e.target.closest('.node'); if (!b) { $('tip').hidden = true; return; }
  const r = b.getBoundingClientRect(), tip = $('tip');
  tip.innerHTML = itemTipHTML(SG.ITEM[b.dataset.buy], false); tip.hidden = false;
  tip.style.left = Math.max(8, r.left - 336) + 'px'; tip.style.bottom = Math.max(8, innerHeight - r.bottom) + 'px';
});
$('shop-tree').addEventListener('mouseleave', () => { $('tip').hidden = true; });
$('shop-grid').addEventListener('mouseleave', () => { $('tip').hidden = true; });
$('shop-grid').addEventListener('mouseover', (e) => {
  if (touchMode) return; // 觸控：長按才看說明（點一下的相容滑鼠事件會讓說明一直留在畫面上）
  const b = e.target.closest('.item'); if (!b) return;
  const it = SG.ITEM[b.dataset.id];
  note(`${it.name}（${world.priceOf(world.player, it)} 金）${SG.itemStatText(it) ? '　' + SG.itemStatText(it) : ''}　${it.text || ''}${b.title ? '　→ ' + b.title : ''}`);
  const r = b.getBoundingClientRect(), tip = $('tip');
  tip.innerHTML = itemTipHTML(it, false); tip.hidden = false;
  tip.style.left = Math.max(8, r.left - 336) + 'px'; tip.style.bottom = Math.max(8, innerHeight - r.bottom) + 'px';
});
function note(t) { $('shop-note').textContent = t; }
$('shop-own').addEventListener('click', (e) => {
  const b = e.target.closest('[data-sell]'); if (!b || b.disabled || !world) return;
  const i = +b.dataset.sell, it = world.player.items[i];
  if (it && world.sell(world.player, i)) { note(`賣出 ${it.name}，拿回 ${SG.sellPrice(it)} 金`); buzz(10); $('shop-own').dataset.sig = ''; renderShop(); }
});
function toggleShop() { $('shop').hidden = !$('shop').hidden; $('tip').hidden = true; if (!$('shop').hidden) { shopSig = ''; renderShop(); } }
// ---------- 觸控：長按道具或商店裝備看說明，放開就收起；點一下照常使用／購買 ----------
let lp = { timer: 0, fired: false };
function longPressed() { const f = lp.fired; lp.fired = false; return f; }
function bindLongPress(box, sel, show) {
  box.addEventListener('pointerdown', (e) => {
    if (!touchMode) return;
    const b = e.target.closest(sel); if (!b) return;
    lp.fired = false; clearTimeout(lp.timer);
    lp.timer = setTimeout(() => { lp.fired = true; show(b); buzz(12); }, 420);
  });
  const end = () => { clearTimeout(lp.timer); if (touchMode) $('tip').hidden = true; };
  box.addEventListener('pointerup', end); box.addEventListener('pointercancel', end); box.addEventListener('pointerleave', end);
}
bindLongPress($('items'), '.it', (b) => showItemTip(world.player.items[+b.dataset.i], b, true));
// 道具換位置（v0.3.0）：按住道具拖到另一格放開。滑鼠、觸控都一樣；拖動超過 12px 就不算點擊或長按
let itemDrag = null;
$('items').addEventListener('pointerdown', (e) => {
  const b = e.target.closest('.it'); if (!b || !world || !world.player.items[+b.dataset.i]) return;
  itemDrag = { i: +b.dataset.i, x: e.clientX, y: e.clientY, on: false, el: b };
});
addEventListener('pointermove', (e) => {
  if (!itemDrag) return;
  if (!itemDrag.on && Math.hypot(e.clientX - itemDrag.x, e.clientY - itemDrag.y) > 12) { itemDrag.on = true; clearTimeout(lp.timer); $('tip').hidden = true; itemDrag.el.classList.add('dragging'); }
  if (itemDrag.on) { document.querySelectorAll('#items .it.drop').forEach((x) => x.classList.remove('drop')); const o = document.elementFromPoint(e.clientX, e.clientY), t = o && o.closest('#items .it'); if (t && t !== itemDrag.el) t.classList.add('drop'); }
});
addEventListener('pointerup', (e) => {
  if (!itemDrag) return;
  const d = itemDrag; itemDrag = null;
  d.el.classList.remove('dragging'); document.querySelectorAll('#items .it.drop').forEach((x) => x.classList.remove('drop'));
  if (!d.on) return;
  lp.fired = true; // 接下來的 click 不要使用／賣出
  const o = document.elementFromPoint(e.clientX, e.clientY), t = o && o.closest('#items .it');
  if (t && +t.dataset.i !== d.i && world.swapItems(world.player, d.i, +t.dataset.i)) buzz(8);
});
addEventListener('pointercancel', () => { if (itemDrag) { itemDrag.el.classList.remove('dragging'); itemDrag = null; } });
bindLongPress($('shop-grid'), '.item', (b) => { const it = SG.ITEM[b.dataset.id], r = b.getBoundingClientRect(), tip = $('tip'); tip.innerHTML = itemTipHTML(it, false); tip.hidden = false; tip.style.left = Math.max(8, Math.min(innerWidth - 328, r.left - 336 < 8 ? r.right + 8 : r.left - 336)) + 'px'; tip.style.bottom = Math.max(8, innerHeight - r.bottom) + 'px'; });
// 保險：觸控時點到畫面其他地方，說明一定收起
document.addEventListener('pointerdown', (e) => { if (touchMode && !$('tip').hidden && !(e.target instanceof Element && e.target.closest('#tip'))) $('tip').hidden = true; }, true);

// ---------- 戰況 ----------
// × 關閉：戰況表會定時重畫，按鈕會被換掉，所以在容器上聽「按下」
$('board').addEventListener('pointerdown', (e) => { if (e.target instanceof Element && e.target.closest('#board-x')) { e.preventDefault(); showBoard(false); } });
function showBoard(on) { $('board').hidden = !on; $('end').classList.toggle('peek', on && world.over !== null); if (on) renderBoard(); else $('tip').hidden = true; } // 結算後看戰況：先把結算畫面藏起來，關掉再回來
$('board').addEventListener('mouseover', boardTip);
// 查看面板：× 關閉；技能、裝備 hover 看說明
$('insp').addEventListener('pointerdown', (e) => { if (e.target instanceof Element && e.target.closest('#insp-x')) { e.preventDefault(); e.stopPropagation(); insp = null; renderInspect(); } });
$('insp').addEventListener('mouseover', (e) => {
  if (touchMode || !insp) return;
  const t = e.target instanceof Element ? e.target : null, sb = t && t.closest('[data-s]'), ib = t && t.closest('#insp-it [data-i]');
  if (sb && insp.spec) { const i = +sb.dataset.s, sl = insp.skillLv && (insp === world.player || insp.skillLv.some((v) => v > 0)) ? insp.skillLv[i] : null; $('tip').innerHTML = skillTipHTML(insp.spec.skills[i], i, sl); placeTipNear(sb); return; }
  if (ib) { const it = insp.items[+ib.dataset.i]; if (it) { $('tip').innerHTML = itemTipHTML(it, false); placeTipNear(ib); return; } }
  $('tip').hidden = true;
});
$('insp').addEventListener('mouseleave', () => { $('tip').hidden = true; });
$('board').addEventListener('mouseleave', () => { $('tip').hidden = true; });
function renderBoard() {
  if (storyOf(world)) return renderStoryBoard(world);
  const w = world, me = w.player, end = w.over !== null; // 結算後：多三欄傷害統計，不再顯示復活倒數
  const num = (h, k) => `<td class="n">${h.stat && h.stat[k] != null ? Math.round(h.stat[k]).toLocaleString() : '—'}</td>`;
  const row = (h) => `<tr class="${h.isPlayer ? 'mine' : ''}"><td class="hn" data-hid="${h.id}">${h.spec ? `<img class="pt" src="${portraitURL(h.spec, 40)}" alt="">` : ''}${end && h.card ? `${esc(h.spec ? h.spec.name : '')}（<button type="button" class="plink" data-pid="${esc(h.card)}">${esc(h.pname)}</button>）` : h.name}${h.alive || end ? '' : ` <span class="resp">復活 ${Math.ceil(h.respawn)}</span>`}</td><td class="n">${h.lv}</td><td class="n">${h.kills}/${h.deaths}/${h.assists}</td>${end ? num(h, 'dmgHero') + num(h, 'taken') + num(h, 'dmgBld') : ''}<td>${h.items.filter(Boolean).map((i) => `<img src="${SG.itemIconURL(i, 44)}" alt="${i.name}" data-it="${i.id}">`).join('')}</td></tr>`;
  const table = (team) => `<h3 style="color:${team === me.team ? 'var(--ally)' : 'var(--foe)'}">${team ? '魏軍' : '聯軍'}　${w.kills[team]} 殺${end && w.over === team ? '　勝' : ''}</h3><table><colgroup><col class="c-name"><col class="c-lv"><col class="c-kda">${end ? '<col class="c-dmg"><col class="c-dmg"><col class="c-dmg">' : ''}<col class="c-items"></colgroup><thead><tr><th>武將</th><th>等級</th><th>擊殺/陣亡/助攻</th>${end ? '<th>對將傷害</th><th>承受傷害</th><th>拆塔傷害</th>' : ''}<th>裝備</th></tr></thead><tbody>${w.heroes(team).map(row).join('')}</tbody></table>`;
  const hint = end ? (touchMode ? '點右上角 × 回到結算' : '按 × 回到結算 · 滑鼠移到武將或裝備上看說明') : (touchMode ? '點右上角 × 關閉' : '放開 Tab 關閉 · 滑鼠移到武將或裝備上看說明');
  const html = `<button class="x-close" type="button" id="board-x" aria-label="關閉戰況">×</button>` + table(0) + table(1) + `<p style="color:var(--muted);font-size:12px;margin:0">${hint} · 遊戲時間 <span id="board-t"></span></p>`;
  if ($('board').dataset.h !== html) { $('board').dataset.h = html; $('board').innerHTML = html; } // 沒變就不重畫，滑鼠停著的說明才不會閃
  $('board-t').textContent = fmt(w.t);
}

// ---------- 列傳：戰前簡報、任務欄、字幕、旁白卡、Tab 戰況、結算 ----------
const story = { lines: [], lineT: 0, cardT: 0 };
const storyOf = (w) => w && w.campaign && w.campaign.mission;
// 結算、戰況上的稱呼：我方的兵、敵方的兵（每章可以自己定，預設是第 1 章的鄉里少年、黃巾）
const storyWords = (m) => Object.assign({ ally: '鄉里少年', foe: '黃巾' }, m.def.words);
const lootText = (m) => (m.lootN0 + m.loots.length ? `拾獲 ${m.stats.loot}/${m.lootN0 + m.loots.length}` : '');
function startChapter(id, carry) {
  const w = SG.CAMPAIGN.chapter(id, { touch: touchMode, carry });
  begin(w);
  $('guide').hidden = true;
  const m = storyOf(w), ch = m.def, b = ch.brief;
  paused = true;
  const where = SG.CAMPAIGN.partOf(ch.id);
  $('brief').innerHTML = `<div class="br-box"><small>列傳${where ? `・${esc(where.list.name)}・${esc(where.part.name)}` : ''}</small><h2>${esc(SG.CAMPAIGN.title(ch.id))}</h2><p class="yr">${esc(ch.year)}</p>${b.quote.map((q) => `<blockquote>${esc(q.text)}<cite>${esc(q.src)}</cite></blockquote>`).join('')}<p>${esc(b.text)}</p><ol>${b.goals.map((g) => `<li>${esc(g)}</li>`).join('')}</ol><button class="btn primary" id="brief-go" type="button">出陣</button></div>`;
  $('brief').hidden = false;
  $('brief-go').onclick = () => { $('brief').hidden = true; paused = false; last = performance.now(); };
}
function storyHud(w) {
  const m = storyOf(w), now = performance.now() / 1000, dt = Math.min(0.5, now - (story.now || now)); // HUD 是節流更新的：用自己的時鐘算經過時間
  story.now = now;
  $('squest').hidden = !m;
  if (!m) return;
  const html = `<b>${esc(SG.CAMPAIGN.title(m.def.id))}</b>` + m.objs.map((o) => `<div class="${o.done ? 'done' : ''}">${o.done ? '✓' : '◆'} ${esc(o.text)}${o.of ? `　${o.n}/${o.of}` : ''}</div>`).join('');
  if ($('squest').dataset.h !== html) { $('squest').dataset.h = html; $('squest').innerHTML = html; }
  if (!$('brief').hidden) return; // 簡報開著：字幕等出陣再播
  story.cardT -= dt;
  if (story.cardT <= 0) $('ccard').classList.remove('on');
  story.lineT -= dt;
  if (story.lineT <= 0) {
    let l = story.lines.shift();
    while (l && w.t - l.t > 8) l = story.lines.shift(); // 排太久的字幕跳過，免得對白落後劇情
    if (l) { $('cline').innerHTML = `<b>${esc(l.who)}</b>${esc(l.text)}`; $('cline').style.opacity = 1; story.lineT = Math.max(2.8, l.text.length * 0.16); }
    else $('cline').style.opacity = 0;
  }
}
function renderStoryBoard(w) {
  const m = storyOf(w), me = w.player, end = w.over !== null;
  const row = (h) => `<tr class="${h.isPlayer ? 'mine' : ''}"><td class="hn" data-hid="${h.id}"><img class="pt" src="${portraitURL(h.spec, 40)}" alt="">${h.name}</td><td class="n">${h.lv}</td><td class="n">${Math.round(h.hp)}/${Math.round(h.maxHp)}</td><td>${h.items.filter(Boolean).map((i) => `<img src="${SG.itemIconURL(i, 44)}" alt="${i.name}" data-it="${i.id}">`).join('')}</td></tr>`;
  const rec = w.units.filter((u) => u.recruit && u.alive).length, W = storyWords(m);
  const hint = end ? (touchMode ? '點右上角 × 回到結算' : '按 × 回到結算') : (touchMode ? '點右上角 × 關閉' : '放開 Tab 關閉 · 滑鼠移到武將或裝備上看說明');
  const html = `<button class="x-close" type="button" id="board-x" aria-label="關閉戰況">×</button>`
    + `<h3 style="color:#ffd46b">${esc(SG.CAMPAIGN.title(m.def.id))}　<small style="color:var(--muted)">${esc(m.def.year)}</small></h3>`
    + `<div class="sb-obj">${m.objs.map((o) => `<div class="${o.done ? 'done' : ''}">${o.done ? '✓' : '◆'} ${esc(o.text)}${o.of ? `　${o.n}/${o.of}` : ''}</div>`).join('')}</div>`
    + `<h3 style="color:var(--ally)">我軍</h3><table><colgroup><col class="c-name"><col class="c-lv"><col class="c-kda"><col class="c-items"></colgroup><thead><tr><th>武將</th><th>等級</th><th>血量</th><th>裝備</th></tr></thead><tbody>${w.heroes(me.team).map(row).join('')}</tbody></table>`
    + `<p style="margin:10px 0 6px">${[`${W.ally} ${rec} 人`, `擊破${W.foe} ${m.stats.slain}`, `折損 ${m.stats.lost}`, lootText(m), `${Math.floor(me.gold)} 金`].filter(Boolean).join('　·　')}</p>`
    + `<p style="color:var(--muted);font-size:12px;margin:0">${hint} · 遊戲時間 <span id="board-t"></span></p>`;
  if ($('board').dataset.h !== html) { $('board').dataset.h = html; $('board').innerHTML = html; }
  $('board-t').textContent = fmt(w.t);
}
function showStoryEnd(w, toSelect) {
  const m = storyOf(w), win = m.over === 'win', W = storyWords(m);
  if (win && m.def.next) { startChapter(m.def.next, SG.CAMPAIGN.carry(w)); return; } // 分幕的章：直接接下一幕
  const id = m.def.of || w.campaign.chapter; // 分幕的章：星數記在第一幕那章，再打一次也從第一幕開始
  if (win) SG.CAMPAIGN.recordStars(id, m.stars.filter((s) => s.ok).length);
  const stars = win ? `<ul class="stars">${m.stars.map((s) => `<li class="${s.ok ? 'ok' : ''}">${s.ok ? '★' : '☆'} ${esc(s.text)}</li>`).join('')}</ul>` : '';
  const due = win ? Meta.unclaimed({ [id]: SG.CAMPAIGN.stars(id) }) : { nStars: 0 }; // 這章還沒領的星數黃金
  const claim = due.nStars ? `<p><button class="btn primary" type="button" id="end-claim">領取 ${due.nStars * Meta.GOLD_STAR} 黃金（${due.nStars} 顆星）</button></p>` : '';
  $('end-box').innerHTML = `<div class="side2"><h2 style="color:${win ? 'var(--ally)' : 'var(--foe)'}">${win ? '勝利' : '戰敗'}</h2><p>${esc(SG.CAMPAIGN.title(m.def.id).replace(/（[上下]）/, ''))} · ${fmt(m.stats.t)}${win ? '' : ' · ' + esc(m.why)}</p>${stars}${claim}<p>${[`擊破${W.foe} ${m.stats.slain}`, `${W.ally}折損 ${m.stats.lost}`, lootText(m)].filter(Boolean).join(' · ')}</p><div class="acts"><button class="btn primary" type="button" id="again">${win ? '再打一次' : '重新挑戰'}</button><button class="btn" type="button" id="back">離開</button><button class="btn" type="button" id="end-board">戰況</button></div></div>`;
  $('end').hidden = false;
  $('again').onclick = () => { showBoard(false); $('end').hidden = true; startChapter(id); };
  if ($('end-claim')) $('end-claim').onclick = async (e) => { e.target.disabled = true; const got = await SG.Cloud.claimRewards({ stars: due.stars }); if (got) e.target.textContent = `已領取 ${got.gold} 黃金`; else e.target.disabled = false; };
  $('back').onclick = () => { SG.CAMPAIGN.leave(); toSelect(); };
  $('end-board').onclick = () => showBoard(true);
}

// ---------- 結算 ----------
function showEnd() {
  const w = world, me = w.player, win = w.over === me.team;
  const back = w.net ? 'hall' : storyOf(w) ? 'campaign' : 'practice'; // 列傳打完回列傳分頁
  const toSelect = () => { showBoard(false); document.body.classList.remove('touch-ui'); SG.CAM_H = 0; $('end').hidden = true; $('hud').hidden = true; $('game').hidden = true; $('select').hidden = false; world = null; renderGrid(); if (SG.Home) SG.Home.show(back); else renderChosen(); };
  if (storyOf(w)) return showStoryEnd(w, toSelect);
  const mvp = w.heroes().slice().sort((a, b) => b.kills * 2 + b.assists - b.deaths - (a.kills * 2 + a.assists - a.deaths))[0];
  if (w.net || !me.stat) {
    $('end-box').innerHTML = `<div class="side2"><h2 style="color:${win ? 'var(--ally)' : 'var(--foe)'}">${win ? '勝利' : '戰敗'}</h2><p>你的戰績：${me.kills}/${me.deaths}/${me.assists}，本場最佳：${mvp.name}</p><div class="acts"><button class="btn primary" type="button" id="again">回大廳</button><button class="btn" type="button" id="end-board">團隊戰況</button></div></div>`;
    $('end').hidden = false; $('again').onclick = toSelect; $('end-board').onclick = () => showBoard(true);
    return;
  }
  const r = Meta.record(w, matchCtx), s = r.s;
  // 會員：向伺服器領這場的銅錢（伺服器限制領取間隔與每天上限），顯示實際入帳
  // 順便回報整場的對戰數據（兩隊武將、裝備、傷害），給後台的平衡分析（v0.5.1.1）
  if (r.cloudWallet) SG.Cloud.econ('econ/practice', Object.assign({ board: SG.matchBoard(w), battle: matchCtx.battle || 'chibi', ver: VERSION }, r.claim)).then((j) => {
    const el = $('end-copper'); if (!el) return;
    el.textContent = j.ok ? '+' + j.granted : '+0';
    if (j.ok && j.capped) el.title = '今天單機練習的銅錢已達上限；連線對戰不受限制';
    if (j.ok && j.capped) el.insertAdjacentHTML('afterend', '<small class="cap-note">今日練習銅錢已達上限</small>');
    if (!j.ok) el.insertAdjacentHTML('afterend', `<small class="cap-note">${j.err}</small>`);
  });
  const ch = matchCtx.challenge;
  $('end-box').innerHTML = `<div><canvas class="cardimg" id="card" aria-label="戰報卡"></canvas>
      <div class="share"><button class="btn primary" type="button" id="sh-share">分享戰報</button><button class="btn" type="button" id="sh-link">複製挑戰連結</button><button class="btn" type="button" id="sh-img">存戰報圖</button><p class="note" id="sh-note" aria-live="polite"></p></div></div>
    <div class="side2">
      <div class="res"><h2 style="color:${win ? 'var(--ally)' : 'var(--foe)'}">${win ? '勝利' : '戰敗'}</h2><p>${BATTLES[matchCtx.battle || 'chibi'].name} · ${s.mode === 'quick' ? '速戰' : '標準'} · ${fmt(w.t)} · 本場最佳 ${mvp.name}</p></div>
      ${ch ? `<div class="vs">挑戰 ${ch.name ? esc(ch.name) : '朋友'}：你的戰功分 <b>${s.score.toLocaleString()}</b> vs <b>${ch.score.toLocaleString()}</b>　${s.score > ch.score ? '<b style="color:var(--hp)">挑戰成功！</b>把戰報傳回去吧' : '差一點，再來一場？'}</div>` : ''}
      ${me.stat ? `<div class="end-stats"><span>對將傷害 <b>${Math.round(me.stat.dmgHero || 0).toLocaleString()}</b></span><span>承受傷害 <b>${Math.round(me.stat.taken || 0).toLocaleString()}</b></span><span title="按住防禦時擋下的傷害總和">累計抵禦傷害 <b>${Math.round(me.stat.blocked || 0).toLocaleString()}</b></span></div>` : ''}
      ${r.newBest && Meta.profile.heroes[me.spec.id].games > 1 ? `<div class="chip new" style="justify-self:start">${me.spec.name} 個人最佳紀錄</div>` : ''}
      <div class="gain">${r.parts.map((p, i) => `<div style="animation-delay:${0.15 + i * 0.12}s"><span>${p[0]}</span><b>+${p[1]}</b></div>`).join('')}<div class="tot" style="animation-delay:${0.2 + r.parts.length * 0.12}s"><span>軍功</span><b>+${r.gain}</b></div><div class="tot" style="animation-delay:${0.3 + r.parts.length * 0.12}s" title="${r.coins.map((c) => c[0] + ' +' + c[1]).join('、')}"><span>銅錢</span><b style="color:#f0b27a" id="end-copper">${r.cloudWallet ? '入帳中…' : '+' + r.copper}</b></div></div>
      <div class="mastery"><div>軍階 <b>${r.rank1.name}</b>${r.rankUp ? '　<span class="lvup">晉升！</span>' : ''}</div><div class="meter"><i id="rk-bar" style="--p:${(r.rankUp ? 0 : r.rank0.frac).toFixed(3)}"></i></div></div>
      <div class="mastery"><div>${me.spec.name} 熟練度 <b>Lv${r.m1.lv} ${r.m1.name}</b> +${r.mGain}${r.masteryUp ? '　<span class="lvup">升級！</span>' : ''}</div><div class="meter"><i id="m-bar" style="--p:${(r.masteryUp ? 0 : r.m0.frac).toFixed(3)}"></i></div></div>
      ${r.unlocks.length ? `<div class="chips">${r.unlocks.map((k) => `<span class="chip new">解鎖造型：${me.spec.name}・${k.name}</span>`).join('')}</div>` : ''}
      ${r.newAch.length ? `<div class="chips">${r.newAch.map((a) => `<span class="chip new" title="${a.desc}">戰功：${a.name}</span>`).join('')}</div>` : ''}
      <div class="card"><h3>今日軍令</h3>${r.qs.map((q) => `<div class="quest${q.done ? ' done' : ''}"><div>${q.text}</div><span>${q.done ? '完成' : `${q.n.toLocaleString()}/${q.goal.toLocaleString()}`}</span><div class="meter"><i style="--p:${Math.min(1, q.n / q.goal).toFixed(3)}"></i></div></div>`).join('')}</div>
      <div class="acts"><button class="btn primary" type="button" id="again">再戰一場</button><button class="btn" type="button" id="back">回練習</button><button class="btn" type="button" id="end-board">團隊戰況</button></div>
    </div>`;
  $('end').hidden = false;
  const cv = $('card');
  SG.Share.draw(cv, r, me.spec, { scale: Math.min(2, window.devicePixelRatio || 1) });
  requestAnimationFrame(() => setTimeout(() => { $('rk-bar').style.setProperty('--p', r.rank1.frac.toFixed(3)); $('m-bar').style.setProperty('--p', r.m1.frac.toFixed(3)); }, 400));
  if (SG.Audio && (r.rankUp || r.masteryUp || r.newAch.length)) setTimeout(() => SG.Audio.play('levelup'), 600);
  const note = (t) => { $('sh-note').textContent = t; };
  $('sh-share').onclick = async () => note(await SG.Share.share(cv, r, me.spec));
  $('sh-link').onclick = async () => note(await SG.Share.copy(SG.Share.text(r, me.spec) + '\n' + SG.Share.link(r)));
  $('sh-img').onclick = async () => note(await SG.Share.copyImage(cv));
  $('again').onclick = () => { showBoard(false); start(SG.HEROES.find((h) => h.id === me.spec.id)); };
  $('back').onclick = toSelect;
  $('end-board').onclick = () => showBoard(true);
}

SG.debug = () => ({ world, view, start });
SG.Game = {
  begin, portrait, start, showPing, guideHTML, buzz, fullscreen, BATTLES, SCHEMES, settings, saveSettings, keyRows, bindSkins, masteryBlock, elTag, lv1, termsLi, FACTION,
  chosen: () => chosen, choose(h) { chosen = h; renderGrid(); renderChosen(); }, renderChosen, renderGrid,
  tryOn(h, sk) { pvTry = { h: h.id, sk }; chosen = h; renderGrid(); renderChosen(); }, // 商域「試看」：到練習頁預覽這款造型
  get challenge() { return challenge; }, clearChallenge() { challenge = null; },
  startChapter, // 列傳分頁開章
};
// 列傳：首頁的「列傳」分頁開章；開發時也能用 game.html?lz=sunwu-6 直接開某一章，?lz=xihua 只看地圖
try {
  const lz = new URLSearchParams(location.search).get('lz');
  if (lz && SG.CAMPAIGN && chapterOpen(SG.CAMPAIGN.chapters, lz)) setTimeout(() => startChapter(lz), 300);
  else if (lz && SG.CAMPAIGN && SG.CAMPAIGN.maps[lz]) setTimeout(() => { begin(SG.CAMPAIGN.world(lz, SG.HEROES.find((h) => h.id === 'sunjian'))); world.say(`列傳預覽：${SG.MAP.name}（開發中）`, 'big'); }, 300);
} catch (e) { console.error(e); }
if (document.fonts && document.fonts.load) document.fonts.load('900 17px "Noto Serif TC"', '劉孫曹漢吳盟魏酒暈懼定默').catch(() => {});
